// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:22.806Z
// Property: San Marino Apartments (ID: 6737460151191767)
// Collections: 31 amenities, 14 floorplans (live), 32 photos, 82 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191767",
  "property_external_id": "4871557",
  "property_zillow_url": "https://www.zillow.com/homedetails/15255-Vintage-Preserve-Houston-TX-77070/2077906380_zpid/",
  "property_apartments_url": "https://www.apartments.com/san-marino-apartments-houston-tx/91298h4",
  "property_google_business_url": "https://www.google.com/maps/place/San+Marino/data=!4m2!3m1!1s0x0:0x691b3973489ce6d3?sa=X&ved=2ahUKEwi0w6WWvrySAxVslJUCHR_kIWUQ_BJ6BAg4EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321132574",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "san-marino-apartments",
  "property_name": "San Marino Apartments",
  "property_website_url": "https://www.sanmarino-houston.com/",
  "property_domain": "https://www.sanmarino-houston.com/",
  "property_address": "15255 Vintage Preserve Pkwy",
  "property_full_address": "15255 Vintage Preserve Pkwy, Houston, TX 77070",
  "property_address_1": "15255 Vintage Preserve Pkwy",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77070-2199",
  "property_address_zip": "77070",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Cypresswood",
  "property_address_latitude": "29.9967687",
  "property_address_longitude": "-95.55811829999999",
  "property_email": "sanmarino@rreafresidential.com",
  "property_phone": "(713) 575-1325",
  "property_call_tracking_phone": "713-597-6725",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to San Marino Apartments in Houston, TX, where comfort meets convenience! Choose from our spacious one and two-bedroom floor plans, all at competitive prices. Discover why we’re the price leader in the area. Find your new home today—browse our availability or schedule a tour to experience our vibrant community!",
  "property_long_description": "Welcome to San Marino Apartments, where contemporary living meets unparalleled comfort in the heart of Houston, TX. Our thoughtfully designed community offers a variety of spacious floor plans, including one-bedroom and two-bedroom apartments, catering to individuals and families alike. Whether you desire a cozy retreat or a more expansive space, San Marino Apartments has the perfect home for you.\n\nAs a price leader in the area, we pride ourselves on offering exceptional value without compromising on quality. Our apartments feature modern finishes, abundant natural light, and functional layouts that suit your lifestyle. Enjoy the convenience of in-unit amenities, as well as access to our community's state-of-the-art facilities, designed to enhance your living experience.\n\nAt San Marino Apartments, you'll find yourself surrounded by a vibrant neighborhood that offers a variety of shopping, dining, and entertainment options just minutes away. Plus, our prime location ensures easy access to major highways and public transportation, making your daily commute a breeze.\n\nReady to discover your new home? Browse our available floor plans or schedule a tour to visit our welcoming community today! With limited availability and a highly desirable location, your dream apartment is just a click away. Experience the best of Houston living at San Marino Apartments—where comfort, convenience, and community come together.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury apartment community pool and hot tub at sunset.",
    "public_id": "019d076f-418f-7469-a820-77e87e1ebb06",
    "storage_key": "property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
    "width": 1240,
    "height": 825
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "241",
  "property_year_built": "2016",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.6804979253112",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$175\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No deposit or fees are required for service animals.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://sanmarinoapartments.loftliving.com/login",
  "property_apply_now_url": "https://8754819.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-4f1e-73d9-abaf-9061c9397c2b.webp",
  "property_primary_logo_media": {
    "alt_text": "San Marino logo.",
    "public_id": "019e1e2a-4f1e-73d9-abaf-9061c9397c2b",
    "storage_key": "property/6737460151191767/019e1e2a-4f1e-73d9-abaf-9061c9397c2b.webp",
    "width": 700,
    "height": 401
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-4f3b-726f-8113-94720f3860fd.webp",
  "property_secondary_logo_media": {
    "alt_text": "San Marino property logo",
    "public_id": "019e1e2a-4f3b-726f-8113-94720f3860fd",
    "storage_key": "property/6737460151191767/019e1e2a-4f3b-726f-8113-94720f3860fd.webp",
    "width": 700,
    "height": 401
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-4f3b-726f-8113-94720f3860fd.webp",
  "property_mono_white_logo_media": {
    "alt_text": "San Marino property logo",
    "public_id": "019e1e2a-4f3b-726f-8113-94720f3860fd",
    "storage_key": "property/6737460151191767/019e1e2a-4f3b-726f-8113-94720f3860fd.webp",
    "width": 700,
    "height": 401
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a2-3048-72c4-a1cb-6f609ae819c7.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e84a2-3048-72c4-a1cb-6f609ae819c7",
    "storage_key": "property/6737460151191767/019e84a2-3048-72c4-a1cb-6f609ae819c7.webp",
    "width": 700,
    "height": 401
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#d6f7ff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "560 - 1207",
  "property_sqft_min": "560",
  "property_sqft_max": "1207",
  "property_price_range": "999 - 1975",
  "property_price_min": "999",
  "property_price_max": "1975",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/SMO.HOU.TX/",
  "property_instagram_url": "https://www.instagram.com/san_marino_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJbdkrRH_NQIYR0-acSHM5G2k",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/san-marino-apartments-houston-2",
  "property_tiktok_url": "https://www.tiktok.com/@smo.htx",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to San Marino Apartments",
  "property_home_romance_title": "Experience Love at First Sight in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>A convenient lifestyle awaits you at San Marino Apartments in Houston, TX. <a href=\"/neighborhood/\">Restaurants, shopping, and prime entertainment destinations</a> surround our gated community. Close proximity to the Tomball Parkway paves the way to an eventful day almost anywhere in the great state of Texas! Envision coming home to the best-kept secret in quality apartments.</p>\n<p>Our <a href=\"/floor-plans/\">one and two bedroom apartment homes</a> for rent offer sixteen splendid floor plan options with lavish amenities. Modern lighting complements the custom granite countertops, designer tile, and wood-style flooring throughout each apartment. You will love the luxurious bathroom with oversized soaking tub, spacious walk-in closets, and stainless steel appliance package. We understand pets are part of the family and have a <a href=\"/amenities/\">pet washing station and bark park</a> for their enjoyment.</p>",
  "property_home_floorplans_blurb": "<p>Situated just south of the center of Spring, Texas, Cypresswood is a charming suburban locale set around one of the area’s most convenient thoroughfares, Cypresswood Drive. To the east sits the Spring Creek Greenway and Pundt Park, both of which provide amazing views of the creek and the lush greenery that surrounds it. Proximity to Downtown Spring means that even in this quiet, suburban area you’re never from convenient shops and grocery stores. Downtown Houston is just a 30-minute drive south should you want to explore the big city.</p>",
  "property_home_gallery_blurb": "Welcome to San Marino Apartments in Houston, TX, where luxury meets lifestyle. Choose from our stylish one, two, or three-bedroom floor plans, and enjoy exceptional amenities like a modern fitness center, ultra-luxe leisure pool, and chic social spaces. Picture yourself living here—comfort and elegance await!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding San Marino Apartments in Houston, TX. Explore our spacious one and two-bedroom floor plans while enjoying easy access to local favorites and nearby attractions. See what's around our community and immerse yourself in the lively lifestyle that awaits you! ",
  "property_home_reviews_blurb": "At San Marino Apartments, residents rave about the welcoming atmosphere and attentive staff. One delighted tenant shares, \"The office staff is...kind and actually make you feel important.\" Experience the comfort of a community where your needs are prioritized. Dive into what our residents love about living here!",
  "property_neighborhood_blurb": "<p>Situated just south of the center of Spring, Texas, Cypresswood is a charming suburban locale set around one of the area’s most convenient thoroughfares, Cypresswood Drive. To the east sits the Spring Creek Greenway and Pundt Park, both of which provide amazing views of the creek and the lush greenery that surrounds it. Proximity to Downtown Spring means that even in this quiet, suburban area you’re never from convenient shops and grocery stores. Downtown Houston is just a 30-minute drive south should you want to explore the big city.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>We provide a <a href=\"/gallery/\">magnificent 24-hour fitness center</a> and the socializing activities are endless. Visit our internet cafe, play billiards, or relax in our outdoor veranda with a summer kitchen. Rejuvenate by the ultra-luxe leisure pool and spa. You won't want to miss our incredible San Marino apartments in Houston, TX.</p>",
  "property_applynow_blurb": "Discover your ideal living space at San Marino Apartments in Houston, TX! Choose from our spacious one and two-bedroom floor plans, designed for comfort and style. As a price leader in the area, we offer exceptional value. Apply now and find your new home—lease online today!",
  "property_contactus_blurb": "Discover your perfect home at San Marino Apartments in Houston, TX! Explore our inviting one and two-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today to learn more and schedule your visit to experience the vibrant community waiting for you!",
  "property_faqs_blurb": "Discover your ideal living space at San Marino Apartments in Houston, TX, with our diverse floor plans, featuring one and two-bedroom options. Have questions? Browse our FAQs page to find answers about our vibrant community and living experience. Your perfect home awaits!",
  "property_floorplans_blurb": "<p>San Marino defines luxury with our selection of one and two bedroom apartments, specifically designed to suit your every need. Our apartments feature custom granite countertops throughout, designer tile and wood-style flooring, and spacious walk-in closets all with incredible <a href=\"/gallery/\">contemporary finishes</a> and modern appliances.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at San Marino Apartments in Houston, TX! Choose from spacious one and two-bedroom floor plans, all at competitive prices. Explore our price leader amenities, and make your move today. Use our interactive community map to view available apartments and pricing—your dream home awaits!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover the perfect living space at San Marino Apartments in Houston, TX! Choose from our stylish one and two-bedroom floor plans to suit your lifestyle. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy exclusive rewards! Explore all our options now!",
  "property_residentaccess_blurb": "Welcome to San Marino Apartments in Houston, TX! Explore our spacious one and two-bedroom floor plans designed for your comfort. Access your resident portal today to conveniently pay rent, schedule maintenance, and stay updated on community news. Your ideal living experience awaits at San Marino Apartments!",
  "property_reviews_blurb": "At San Marino Apartments in Houston, residents rave about the exceptional community atmosphere. With friendly staff who \"make you feel important\" and prompt maintenance that addresses needs swiftly, it's no wonder newcomers feel right at home. See what our residents have to say about living at our community!",
  "property_created_at": "1752257093704",
  "property_scheduletour_blurb": "Discover your perfect home at San Marino Apartments in Houston, TX! Choose from our spacious one-bedroom and two-bedroom floor plans designed for comfort and convenience. Schedule a tour today and see what our residents have to say about living in this vibrant community. Your dream apartment awaits!",
  "property_thankyou_blurb": "Thank you for your interest in San Marino Apartments in Houston, TX! Explore our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. A team member will contact you shortly to assist you further. Discover your perfect home today!",
  "property_virtualtours_blurb": "<p>At San Marino, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. San Marino Apartments",
  "property_seo_title_home": "San Marino Apartments | Apartments in Houston, TX",
  "property_seo_description_home": "Discover your perfect sanctuary at San Marino Apartments in Houston, TX! Explore our spacious one and two-bedroom floor plans, designed for comfortable living. As the price leader in the area, we offer exceptional amenities to enhance your lifestyle. Don’t miss out—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Houston, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at San Marino Apartments in Houston, TX! Explore our thoughtfully designed floor plans, featuring spacious one and two-bedroom options. Browse our available apartment homes today and find the perfect floor plan that fits your lifestyle. Start your journey to comfortable living now!",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover the exceptional amenities and stylish floor plans at San Marino Apartments in Houston, TX. Choose from our spacious one and two-bedroom options, designed for comfort and convenience. As the price leader in the area, we invite you to explore everything our vibrant community has to offer. Your new home awaits—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "Discover the vibrant lifestyle at San Marino Apartments in Houston, TX! Explore our stunning photo gallery showcasing spacious one and two-bedroom floor plans designed to fit your needs. As a price leader in the area, we offer unmatched value and amenities for a comfortable living experience. Picture yourself living in your dream home today!",
  "property_seo_title_virtualtours": "Virtual Tours | San Marino Apartments Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at San Marino Apartments in Houston, TX! Explore our spacious one and two-bedroom floor plans and experience the vibrant community through our immersive virtual tour. Don’t miss your chance to see why San Marino is the ideal choice for modern living. Take a virtual tour of our community and apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | San Marino Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at San Marino Apartments in Houston, TX! Explore our interactive community map to find one- and two-bedroom floor plans, check pricing, and see why we’re the price leader in the area. Start your journey to elegant living today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding San Marino Apartments in Houston, TX! Explore our one and two-bedroom floor plans and see what's around our community. Uncover local favorites and nearby points of interest that make living here truly special. Dive into Houston's best—start your exploration today!",
  "property_seo_title_contact": "Contact Us | San Marino Apartments",
  "property_seo_description_contact": "Discover the perfect home at San Marino Apartments in Houston, TX! Choose from our spacious one and two-bedroom floor plans designed for your comfort. Have questions? Contact our leasing team today for more information and let us help you find your ideal apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "Discover the San Marino Apartments in Houston, TX! Explore our one and two-bedroom floor plans designed for your comfort and lifestyle. As a price leader in the area, we offer exceptional amenities and answers to your queries. Browse our FAQs page to find solutions to your most pressing questions about our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "Discover San Marino Apartments in Houston, TX! Explore our spacious one and two-bedroom floor plans and enjoy being the price leader in comfort and convenience. Uncover what makes our community unique—check out resident reviews to see why our residents love calling San Marino home. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "Discover your perfect living space at San Marino Apartments in Houston, TX! Explore our diverse floor plans, including cozy one-bedroom and spacious two-bedroom options, all designed with your comfort in mind. As a price leader in the area, we offer exceptional amenities that elevate your living experience. Ready to make the move? Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | San Marino Apartments",
  "property_seo_description_residentaccess": "\"Welcome to San Marino Apartments in Houston, TX! Access your resident portal to effortlessly pay rent, schedule maintenance, and manage all your community needs. Experience convenience at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | San Marino Apartments",
  "property_seo_description_referafriend": "\"Discover the vibrant community at San Marino Apartments in Houston, TX! Refer a friend today and enjoy exclusive rewards. Great friends make great neighbors – share the experience of luxurious living with your loved ones! ",
  "property_seo_title_scheduletour": "Schedule a Tour | San Marino Apartments",
  "property_seo_description_scheduletour": "\"Discover your perfect home at San Marino Apartments in Houston, TX! Schedule a tour today and explore our vibrant community, modern amenities, and stylish living spaces. Don't miss out—your dream apartment awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | San Marino Apartments",
  "property_seo_description_privacy": "\"Discover peace of mind at San Marino Apartments in Houston, TX. Our privacy policy outlines how we protect your information while providing exceptional living experiences. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | San Marino Apartments",
  "property_seo_description_accessibility": "\"Discover San Marino Apartments in Houston, TX, where we prioritize accessibility for all. Our Accessibility Statement showcases our commitment to digital inclusion, ensuring everyone can easily navigate our community resources. Join us in creating an inclusive environment – learn more today!\"",
  "property_seo_title_sitemap": "Sitemap | San Marino Apartments",
  "property_seo_description_sitemap": "Discover the layout of San Marino Apartments in Houston, TX, with our comprehensive sitemap. Easily explore our amenities, floor plans, and community features. Navigate effortlessly to find your ideal apartment home—view our website sitemap today!",
  "property_seo_title_thankyou": "Thank You | San Marino Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to San Marino Apartments in Houston, TX! Your inquiry is important to us, and a member of our friendly team will be in touch shortly to assist you. Explore our vibrant community and discover your new home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Houston, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293558035",
  "amenities": [
    {
      "id": "ec_6ac0f49bb0fa0516fa28f852",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Fitness Center With CrossFit‑inspired Equipment and Interactive Spin/Cardio Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a06eb86cba0ab64b160b562a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6483bdbe6fe6ca054932ce7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Business Conference Center With Catering Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_748886ca813044baa5984978",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Chic Social Areas With Billiard Table and TVs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09357b2723fb7d93806646dc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50834394ed2e8ddcab0c325f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Cycle station With Peloton Bikes and All‑New Tonal Workout Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_263614c969f0ac61abc48e90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Wash Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a952b31fcc8e78101b143abf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8a84ff940adc73dea864db0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Internet Cafe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75bc015f8164295b9ec4dc70",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_473d9cac58d0d962af237611",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Veranda With Summer Kitchen and Gas Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c104bd3815f13ea32984ae57",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Package Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_618137392f2fdd9209270355",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e44bb477d1c880c6e897660",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Sleek Mid‑rise Living Elevators",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9353576ad0c901a2b73ccad3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Smoke‑free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a695b7310c239ae35edbfe64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Storage Rooms Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_144e464ec252e4e740907b61",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Ultra Luxe Leisure Pool, Lap Pool, and Social Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6247fe8decfe715658165303",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Valet Trash Service and Recycling Programs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_577457e53b7f2e7a9593eb26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "9‑12 Ft. Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab2d7cd753389891d128621c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ef5cc1368839e3fdb30deee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Contemporary Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31782d3bfe3900bc595d7f02",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Custom Cabinetry With Brushed Nickel Accents",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91ab252999f7abf55340f540",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Custom Granite Countertops Throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad6b3e194c19f59d0167082d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Tile and Wood‑style Flooring Throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbaecf25d4c3a9ad970ced9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Individual Intrusion Alarms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f5c73a60657c7f009c79f9b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Luxurious Bathrooms With Custom Framed Mirrors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf1fe2a38770cf7e864888f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8dd6cd6697a90e1cde28d33e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Oversized Soaking Tubs and Walk‑in Showers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39c47ff942996ae611144ffe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Side‑by‑side or Front Loading Washer and Dryer in Home*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a24d26ddeddde68cf382f8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Walk‑in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c04aa683ec63d2e55476a7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_41b367f4-affe-4dab-b5f7-fbdc24701b27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-c20a-7799-9de1-95eb4ec937bb.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a large swimming pool and hot tub area, surrounded by lounge chairs and palm trees.",
        "public_id": "019e84a0-c20a-7799-9de1-95eb4ec937bb",
        "storage_key": "property/6737460151191767/019e84a0-c20a-7799-9de1-95eb4ec937bb.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our stunning swimming pool and relaxing hot tub, perfect for unwinding after a long day. The spacious sundeck and cabanas offer ample room for relaxation.",
      "link": "",
      "alt_text": "Modern apartment complex with a large swimming pool and hot tub area, surrounded by lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_986de83a-edb1-427b-ae29-07f2870cd5de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-ecef-76b2-b620-9dd09ff4a61b.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room with island and sectional sofa.",
        "public_id": "019e84a0-ecef-76b2-b620-9dd09ff4a61b",
        "storage_key": "property/6737460151191767/019e84a0-ecef-76b2-b620-9dd09ff4a61b.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment with a fully equipped kitchen, island seating, and a comfortable living area perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and living room with island and sectional sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9d4e62f-1072-4614-b7c9-e66ea47de8ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-7508-75f1-94d9-327313deb4da.webp",
      "image_media": {
        "alt_text": "Modern living room with sectional sofa, coffee table, and open access to kitchen with bar stools.",
        "public_id": "019fb37b-7508-75f1-94d9-327313deb4da",
        "storage_key": "property/6737460151191767/019fb37b-7508-75f1-94d9-327313deb4da.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area seamlessly connected to a modern kitchen, perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Modern living room with sectional sofa, coffee table, and open access to kitchen with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ec53b8b-9bde-4562-886d-a642c5d90570",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-720e-7775-aaac-3134ed02e5d0.webp",
      "image_media": {
        "alt_text": "Dining area with a table for six, set for a meal, large windows with white curtains.",
        "public_id": "019fb37b-720e-7775-aaac-3134ed02e5d0",
        "storage_key": "property/6737460151191767/019fb37b-720e-7775-aaac-3134ed02e5d0.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy meals in this spacious dining area, featuring a table for six and abundant natural light from large windows.",
      "link": "",
      "alt_text": "Dining area with a table for six, set for a meal, large windows with white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1881793a-edbc-4a2a-898f-f531101f9fca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-7259-77c7-bdac-bebebdf5648c.webp",
      "image_media": {
        "alt_text": "King size bed with tufted headboard and patterned bedding in a bedroom with wood floors and a ceiling fan.",
        "public_id": "019fb37b-7259-77c7-bdac-bebebdf5648c",
        "storage_key": "property/6737460151191767/019fb37b-7259-77c7-bdac-bebebdf5648c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in our spacious bedrooms, featuring plush bedding, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "King size bed with tufted headboard and patterned bedding in a bedroom with wood floors and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_442c47f2-24e8-48ad-ae3e-1350e18fab6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-ed2a-70be-a09b-895ba1d8607c.webp",
      "image_media": {
        "alt_text": "Modern living room with sectional sofa, coffee table, and TV.",
        "public_id": "019e84a0-ed2a-70be-a09b-895ba1d8607c",
        "storage_key": "property/6737460151191767/019e84a0-ed2a-70be-a09b-895ba1d8607c.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, modern coffee table, and a mounted flat-screen TV, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern living room with sectional sofa, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e84eb15e-1ba1-4ae2-a464-d8dfadc34e88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-e9d2-70ab-8f5f-a5755a3eabec.webp",
      "image_media": {
        "alt_text": "A spacious bedroom featuring a king-sized bed with plush bedding, a ceiling fan, and large windows with white curtains.",
        "public_id": "019e84a0-e9d2-70ab-8f5f-a5755a3eabec",
        "storage_key": "property/6737460151191767/019e84a0-e9d2-70ab-8f5f-a5755a3eabec.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Relax in comfort in our beautifully appointed bedrooms. This master suite boasts a king-sized bed, ample natural light, and elegant decor for a tranquil retreat.",
      "link": "",
      "alt_text": "A spacious bedroom featuring a king-sized bed with plush bedding, a ceiling fan, and large windows with white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb769208-a6a5-4357-a8f6-8b37d32383a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-7242-77e7-86a2-89988ec55845.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, washer, dryer, and walk-in closet",
        "public_id": "019fb37b-7242-77e7-86a2-89988ec55845",
        "storage_key": "property/6737460151191767/019fb37b-7242-77e7-86a2-89988ec55845.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity, ample storage, a private toilet area, a walk-in closet, and in-unit washer and dryer.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, washer, dryer, and walk-in closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eea6cd94-54fb-4703-8002-18ebe50efab9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-7194-7279-bd32-1cf271330d3f.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, ceiling fan, and large window with blinds.",
        "public_id": "019fb37b-7194-7279-bd32-1cf271330d3f",
        "storage_key": "property/6737460151191767/019fb37b-7194-7279-bd32-1cf271330d3f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant decor, a ceiling fan for added comfort, and a large window that lets in plenty of natural light.",
      "link": "",
      "alt_text": "Bedroom with king-size bed, ceiling fan, and large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3ea5165-476c-4cc4-a5c7-faea2cbe7a9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-eb9f-778f-bc89-3fa800e15351.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, walk-in closet, and a ceiling fan.",
        "public_id": "019e84a0-eb9f-778f-bc89-3fa800e15351",
        "storage_key": "property/6737460151191767/019e84a0-eb9f-778f-bc89-3fa800e15351.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample closet space, and modern amenities for a relaxed living experience.",
      "link": "",
      "alt_text": "Bedroom with a large bed, walk-in closet, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3ef79ec6-55a5-4a8e-8caf-ca53295b937f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-ea8f-72ea-b37e-8bed9e6030fd.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet with shelves above.",
        "public_id": "019e84a0-ea8f-72ea-b37e-8bed9e6030fd",
        "storage_key": "property/6737460151191767/019e84a0-ea8f-72ea-b37e-8bed9e6030fd.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer located in a convenient laundry closet with ample shelving for storage.",
      "link": "",
      "alt_text": "Washer and dryer in laundry closet with shelves above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ba72e6b-f678-4171-811e-15b35bab7f62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-72ad-746c-bcfc-eb890ae1c238.webp",
      "image_media": {
        "alt_text": "Open-concept living area with a modern kitchen featuring dark wood cabinets, stainless steel appliances, and a mosaic tile backsplash.",
        "public_id": "019fb37b-72ad-746c-bcfc-eb890ae1c238",
        "storage_key": "property/6737460151191767/019fb37b-72ad-746c-bcfc-eb890ae1c238.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in this apartment, complete with a fully equipped kitchen featuring dark wood cabinetry, stainless steel appliances, and a stylish mosaic tile backsplash.",
      "link": "",
      "alt_text": "Open-concept living area with a modern kitchen featuring dark wood cabinets, stainless steel appliances, and a mosaic tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9843a0d9-9b6d-4cdd-acc4-e7e75e604afd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-ea18-76be-a1ae-bf34ec66fd20.webp",
      "image_media": {
        "alt_text": "Modern bathroom with espresso vanity, granite countertop, and chrome fixtures.",
        "public_id": "019e84a0-ea18-76be-a1ae-bf34ec66fd20",
        "storage_key": "property/6737460151191767/019e84a0-ea18-76be-a1ae-bf34ec66fd20.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double espresso vanity with granite countertops, ample storage, and contemporary fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with espresso vanity, granite countertop, and chrome fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea532a2b-b6fc-4f5b-a733-b840037e16a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-7141-70ac-b8b0-3d2f9d1fbe29.webp",
      "image_media": {
        "alt_text": "Ping pong table and pool table in a community lounge.",
        "public_id": "019fb37b-7141-70ac-b8b0-3d2f9d1fbe29",
        "storage_key": "property/6737460151191767/019fb37b-7141-70ac-b8b0-3d2f9d1fbe29.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy recreational activities in the community lounge, featuring a ping pong table and a pool table for resident entertainment.",
      "link": "",
      "alt_text": "Ping pong table and pool table in a community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1e8b575-a710-4e53-bee6-efc8bfd5752f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-dafa-7261-bf06-f0eedc60843b.webp",
      "image_media": {
        "alt_text": "Modern fitness center with various strength training and cardio equipment.",
        "public_id": "019e84a0-dafa-7261-bf06-f0eedc60843b",
        "storage_key": "property/6737460151191767/019e84a0-dafa-7261-bf06-f0eedc60843b.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with everything you need for a complete workout.",
      "link": "",
      "alt_text": "Modern fitness center with various strength training and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_abf5ecc8-abb0-44e7-a0e3-e598b3ba0127",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-db4a-762f-ba62-986e78bc94a6.webp",
      "image_media": {
        "alt_text": "Modern apartment complex gym with Peloton bikes and weight machines.",
        "public_id": "019e84a0-db4a-762f-ba62-986e78bc94a6",
        "storage_key": "property/6737460151191767/019e84a0-db4a-762f-ba62-986e78bc94a6.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with Peloton bikes and a variety of weight training machines.",
      "link": "",
      "alt_text": "Modern apartment complex gym with Peloton bikes and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d07cbdd3-2ef7-494f-9581-bf75571d7ce7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-df79-7460-9bca-bebf8eeb3b0a.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a resort-style pool and lounge chairs.",
        "public_id": "019e84a0-df79-7460-9bca-bebf8eeb3b0a",
        "storage_key": "property/6737460151191767/019e84a0-df79-7460-9bca-bebf8eeb3b0a.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy the resort-style pool at this luxury apartment community, featuring comfortable lounge chairs and a refreshing ambiance.",
      "link": "",
      "alt_text": "Modern apartment complex with a resort-style pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf2e2dc9-a8f3-4930-8b97-373cb9e92ff0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-deda-7531-94f6-5240eba0cf24.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and fountains, adjacent to a brick apartment building.",
        "public_id": "019e84a0-deda-7531-94f6-5240eba0cf24",
        "storage_key": "property/6737460151191767/019e84a0-deda-7531-94f6-5240eba0cf24.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, featuring modern lounge chairs and refreshing fountains. A perfect spot to soak up the sun and enjoy the resort-style amenities.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and fountains, adjacent to a brick apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dfaf22ef-8cab-47dc-b505-21f27c4d56f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-e578-771b-8cc4-cc1e299fa5b7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a modern brick apartment building in the background.",
        "public_id": "019e84a0-e578-771b-8cc4-cc1e299fa5b7",
        "storage_key": "property/6737460151191767/019e84a0-e578-771b-8cc4-cc1e299fa5b7.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and umbrellas, set against the backdrop of our beautiful apartment building.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a modern brick apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc7a2247-70a6-46f3-8015-615ab11b4bff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-e75f-715d-a228-0ebad6d52a51.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern apartment building in the background.",
        "public_id": "019e84a0-e75f-715d-a228-0ebad6d52a51",
        "storage_key": "property/6737460151191767/019e84a0-e75f-715d-a228-0ebad6d52a51.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and lush palm trees. The perfect oasis for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a modern apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57ebb96f-5064-4e42-887f-8475f3893b6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-cc66-72ec-b227-ed2942c08a41.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with tanning ledges and a spa.",
        "public_id": "019e84a0-cc66-72ec-b227-ed2942c08a41",
        "storage_key": "property/6737460151191767/019e84a0-cc66-72ec-b227-ed2942c08a41.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with tanning ledges and a relaxing spa. Perfect for unwinding and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with tanning ledges and a spa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b183a0e-d3d1-4b71-adc4-431b49915780",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-e6ef-700e-a994-28a23fdada91.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a TV overlooking the pool.",
        "public_id": "019e84a0-e6ef-700e-a994-28a23fdada91",
        "storage_key": "property/6737460151191767/019e84a0-e6ef-700e-a994-28a23fdada91.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor lounge area, complete with comfortable seating and a large flat-screen TV, perfect for enjoying the poolside views.",
      "link": "",
      "alt_text": "Outdoor seating area with a TV overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6cd0070b-2bab-4a3e-b7ef-bf805244aa99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-db62-73da-921c-3094db5f19be.webp",
      "image_media": {
        "alt_text": "Covered parking and a dog park with agility equipment.",
        "public_id": "019e84a0-db62-73da-921c-3094db5f19be",
        "storage_key": "property/6737460151191767/019e84a0-db62-73da-921c-3094db5f19be.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy convenient covered parking and an on-site dog park equipped with agility features for your furry friends.",
      "link": "",
      "alt_text": "Covered parking and a dog park with agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad0d0a64-7779-40e7-bc4a-a029d5941dc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-c4bf-7411-b927-028554b98ed4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertops, dark wood vanity, and a walk-in shower with a white curtain.",
        "public_id": "019e84a0-c4bf-7411-b927-028554b98ed4",
        "storage_key": "property/6737460151191767/019e84a0-c4bf-7411-b927-028554b98ed4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and style of this modern apartment bathroom, featuring ample counter space and a refreshing shower.",
      "link": "",
      "alt_text": "Modern bathroom with granite countertops, dark wood vanity, and a walk-in shower with a white curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0eb8e8fe-a675-4c44-9e8c-52039b565a31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-ccda-7707-b688-19501ee44361.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a courtyard with a pool.",
        "public_id": "019e84a0-ccda-7707-b688-19501ee44361",
        "storage_key": "property/6737460151191767/019e84a0-ccda-7707-b688-19501ee44361.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "An aerial view showcases the U-shaped apartment buildings and the central courtyard featuring a swimming pool and lounge area.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounding a courtyard with a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6dd80258-5f95-4823-8e82-79762acf8896",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-d0c6-73a7-abf9-70d6230cdfe1.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a courtyard pool and surrounding parking.",
        "public_id": "019e84a0-d0c6-73a7-abf9-70d6230cdfe1",
        "storage_key": "property/6737460151191767/019e84a0-d0c6-73a7-abf9-70d6230cdfe1.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Expansive aerial view of a modern apartment complex featuring multiple buildings, a central courtyard with a swimming pool, and ample covered parking areas.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a courtyard pool and surrounding parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fbdadf31-81ad-4975-8f07-8064c19a4177",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-caed-73f8-8932-1d563b1b4478.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and surrounding apartment buildings.",
        "public_id": "019e84a0-caed-73f8-8932-1d563b1b4478",
        "storage_key": "property/6737460151191767/019e84a0-caed-73f8-8932-1d563b1b4478.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and spa, surrounded by lush landscaping and modern apartment buildings.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66e18852-c480-4fae-8454-de0c91ab414d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-c824-769a-94eb-1e313a0e6a7b.webp",
      "image_media": {
        "alt_text": "San Marino apartment complex entrance with monument sign and gated driveway.",
        "public_id": "019e84a0-c824-769a-94eb-1e313a0e6a7b",
        "storage_key": "property/6737460151191767/019e84a0-c824-769a-94eb-1e313a0e6a7b.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Welcome to San Marino apartments. The property features a monument sign at the entrance with a secured gated driveway.",
      "link": "",
      "alt_text": "San Marino apartment complex entrance with monument sign and gated driveway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6097e63-d6c4-46a5-ac82-54cf7cdb9a8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e84a0-c776-74be-8e21-b1201c2aeaae.webp",
      "image_media": {
        "alt_text": "Aerial view of a brick apartment building with covered parking and surrounding trees.",
        "public_id": "019e84a0-c776-74be-8e21-b1201c2aeaae",
        "storage_key": "property/6737460151191767/019e84a0-c776-74be-8e21-b1201c2aeaae.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Modern brick apartment complex featuring covered parking, balconies, and lush landscaping. An ideal community setting.",
      "link": "",
      "alt_text": "Aerial view of a brick apartment building with covered parking and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a25b37f9-9c8c-4b87-a8e1-8b58992628a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-725c-74d0-928d-caf1498a50a1.webp",
      "image_media": {
        "alt_text": "Dog park area with agility equipment and covered parking in the background.",
        "public_id": "019fb37b-725c-74d0-928d-caf1498a50a1",
        "storage_key": "property/6737460151191767/019fb37b-725c-74d0-928d-caf1498a50a1.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park with agility features, and benefit from convenient covered parking for residents.",
      "link": "",
      "alt_text": "Dog park area with agility equipment and covered parking in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26c436b6-245f-4fc5-b2d2-33beaf002b41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-775b-72cd-96de-c24682bcc134.webp",
      "image_media": {
        "alt_text": "Modern bathroom with espresso vanity, granite countertop, and large mirror.",
        "public_id": "019fb37b-775b-72cd-96de-c24682bcc134",
        "storage_key": "property/6737460151191767/019fb37b-775b-72cd-96de-c24682bcc134.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious espresso vanity with a granite countertop, large mirror, and a bathtub with a shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with espresso vanity, granite countertop, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b27ec7a-aec4-49c5-ad8c-cf1c40ab25a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019fb37b-730b-739b-93f1-391475ca5d94.webp",
      "image_media": {
        "alt_text": "Elegant lounge area with modern seating, a large island, and decorative ceiling fixtures.",
        "public_id": "019fb37b-730b-739b-93f1-391475ca5d94",
        "storage_key": "property/6737460151191767/019fb37b-730b-739b-93f1-391475ca5d94.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Experience sophisticated comfort in our spacious lounge, featuring stylish seating, a central island, and exquisite lighting. Perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Elegant lounge area with modern seating, a large island, and decorative ceiling fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_dec52fe7-7919-443f-b392-a27fcf9d6d59",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Mia Bella Trattoria",
      "poi_type": "Restaurants",
      "poi_address": "110 Vintage Park Blvd Suite A, Houston, TX 77070, USA",
      "poi_short_description": "Italian restaurant offering classic lunch & dinner fare plus popular weekend brunches & happy hours.",
      "poi_long_description": "Italian restaurant offering classic lunch & dinner fare plus popular weekend brunches & happy hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-c1f9-70c8-be1b-db0b41a016c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-c1f9-70c8-be1b-db0b41a016c2",
        "storage_key": "property/6737460151191767/019e1e2b-c1f9-70c8-be1b-db0b41a016c2.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.miabellarestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17095646171386552784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mia-bella-trattoria",
      "poi_latitude": "29.99473729999999",
      "poi_longitude": "-95.5719939",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-251-8930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG16IMYjSQIYR0CFDw53vP-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_0e848c9e-410b-4ae7-8c6b-6b8aacf3f105",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Hopdoddy Burger Bar",
      "poi_type": "Restaurants",
      "poi_address": "142 Vintage Park Blvd Suite A, Houston, TX 77070, USA",
      "poi_short_description": "Laid-back spot for gourmet burgers, craft beer, fries and shakes, plus gluten-free options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-cc97-7584-9b66-e7040205499c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-cc97-7584-9b66-e7040205499c",
        "storage_key": "property/6737460151191767/019e1e2b-cc97-7584-9b66-e7040205499c.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.hopdoddy.com/locations/vintagepark",
      "poi_directions_map_url": "https://maps.google.com/?cid=12144797062364219843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopdoddy-burger-bar",
      "poi_latitude": "29.9959749",
      "poi_longitude": "-95.5737372",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-554-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBRyhPIjSQIYRw0ltE5X8iqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_40b34fa4-f303-43c7-ae97-0249d51f392f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "El Tiempo Cantina",
      "poi_type": "Restaurants",
      "poi_address": "114 Vintage Park Blvd, Houston, TX 77070, USA",
      "poi_short_description": "Lively branch of a family-run cantina chain known for its margaritas & hearty Tex-Mex dishes.",
      "poi_long_description": "Lively branch of a family-run cantina chain known for its margaritas & hearty Tex-Mex dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-c92f-7278-b59d-c08c087c4da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-c92f-7278-b59d-c08c087c4da7",
        "storage_key": "property/6737460151191767/019e1e2b-c92f-7278-b59d-c08c087c4da7.webp",
        "width": 1280,
        "height": 845
      },
      "poi_business_url": "https://www.eltiempocantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=674168807565243433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-tiempo-cantina",
      "poi_latitude": "29.9947737",
      "poi_longitude": "-95.5725086",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-374-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2UxAO4jSQIYRKTSTZfUgWwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_09f0f201-44e6-4846-b5df-8cbd5349da98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Another Broken Egg Cafe",
      "poi_type": "Restaurants",
      "poi_address": "118A Vintage Park Blvd Bldg G, Houston, TX 77070, USA",
      "poi_short_description": "Casual chain featuring egg dishes & other breakfast items, plus brunch sandwiches.",
      "poi_long_description": "Casual chain featuring egg dishes & other breakfast items, plus brunch sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-c77a-7161-96e0-6c8f1d11ae81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-c77a-7161-96e0-6c8f1d11ae81",
        "storage_key": "property/6737460151191767/019e1e2b-c77a-7161-96e0-6c8f1d11ae81.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anotherbrokenegg.com/locations/houston-tx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16486924335367947456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "another-broken-egg-cafe",
      "poi_latitude": "29.9949022",
      "poi_longitude": "-95.5740437",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-257-3447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvYG8nWLSQIYRwIRZ4FRSzeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_befbe5af-eb4e-4aaf-bcff-b2209299cfe8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "BRIX Wine Cellars",
      "poi_type": "Restaurants",
      "poi_address": "110 Vintage Park Blvd T, Houston, TX 77070, USA",
      "poi_short_description": "Bar with an Italian feel offers a sizable wine selection for pairing with cheeses, entrees & more.",
      "poi_long_description": "Bar with an Italian feel offers a sizable wine selection for pairing with cheeses, entrees & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-c5ff-713b-9dc4-bfdc026f984e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-c5ff-713b-9dc4-bfdc026f984e",
        "storage_key": "property/6737460151191767/019e1e2b-c5ff-713b-9dc4-bfdc026f984e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.brixwinecellars.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15647512212530142883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brix-wine-cellars",
      "poi_latitude": "29.994455",
      "poi_longitude": "-95.571964",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-374-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-4s0Un3SQIYRox5yBnQhJ9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_333ae29b-4a9b-4d97-b853-881b26b7dd71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Mo's Irish Pub",
      "poi_type": "Restaurants",
      "poi_address": "138 Vintage Park Blvd, Houston, TX 77070, USA",
      "poi_short_description": "Festive tavern serving classic pub fare & pints in an airy, Irish-themed space with a patio & music.",
      "poi_long_description": "Festive tavern serving classic pub fare & pints in an airy, Irish-themed space with a patio & music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-c5ea-73be-a86c-642d34a408a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-c5ea-73be-a86c-642d34a408a4",
        "storage_key": "property/6737460151191767/019e1e2b-c5ea-73be-a86c-642d34a408a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mosirishpub.com/vintage-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2685853813209399741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mos-irish-pub",
      "poi_latitude": "29.996046",
      "poi_longitude": "-95.5709457",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-251-0715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-292d-7330-a635-1fa320b06d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-292d-7330-a635-1fa320b06d66",
        "storage_key": "property/6737460151191767/019e1e2c-292d-7330-a635-1fa320b06d66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX7WLojSQIYRvYH5FtARRiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "custom_c93c8ede-cf3f-4512-9951-05a278bd796a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Center Court Pizza and Brew",
      "poi_type": "Restaurants",
      "poi_address": "24345 Gosling Rd Suite 100, Spring, TX 77389, USA",
      "poi_short_description": "Pizza joint with a sporty atmosphere offering hot wings, a big beer selection, sandwiches & salads.",
      "poi_long_description": "Pizza joint with a sporty atmosphere offering hot wings, a big beer selection, sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-d037-760b-b0cc-be6d56da0860.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-d037-760b-b0cc-be6d56da0860",
        "storage_key": "property/6737460151191767/019e1e2b-d037-760b-b0cc-be6d56da0860.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://centercourtpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2258529783315851262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-court-pizza-and-brew",
      "poi_latitude": "30.1190197",
      "poi_longitude": "-95.5073177",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 832-843-6057",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSj4WbkzR4YR_mcuKd_oVx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f3894b7e-3a55-44c0-94cc-47c302749e1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Coco Crepes & Coffee",
      "poi_type": "Restaurants",
      "poi_address": "114 Vintage Park Blvd, Houston, TX 77070, USA",
      "poi_short_description": "Quick, family-friendly spot for sweet & savory crêpes, coffee drinks, teas & smoothies.",
      "poi_long_description": "Quick, family-friendly spot for sweet & savory crêpes, coffee drinks, teas & smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-c4f0-708b-bf5b-fa5d20748af0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-c4f0-708b-bf5b-fa5d20748af0",
        "storage_key": "property/6737460151191767/019e1e2b-c4f0-708b-bf5b-fa5d20748af0.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.cococrepes.com/location/coco-crepes-vintage-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5853273441951462175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coco-crepes--coffee",
      "poi_latitude": "29.9945883",
      "poi_longitude": "-95.5724912",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-378-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2UxAO4jSQIYRH7O--C4BO1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_b529f5fd-e079-4170-ba86-917de4ba61d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Pandan Leaf",
      "poi_type": "Restaurants",
      "poi_address": "126 Vintage Park Blvd F, Houston, TX 77070, USA",
      "poi_short_description": "Casual eatery, known for its Vietnamese sandwiches and coffees, as well as tea-based drinks and fruit smoothies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-cc25-758d-a538-ea6b84d9f040.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-cc25-758d-a538-ea6b84d9f040",
        "storage_key": "property/6737460151191767/019e1e2b-cc25-758d-a538-ea6b84d9f040.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://pandanleaf.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16527992153923052418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pandan-leaf",
      "poi_latitude": "29.995501",
      "poi_longitude": "-95.5718936",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-698-1393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj0NUMIjSQIYRguMGgUs5X-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "custom_ffa04d50-d25b-4b56-b2fa-0c135f40ccb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Gauchos Do Sul",
      "poi_type": "Restaurants",
      "poi_address": "126 Vintage Park Blvd H, Houston, TX 77070, USA",
      "poi_short_description": "Gaucho chefs serve all-you-can-eat meats at this easygoing Brazilian place with a gourmet salad bar.",
      "poi_long_description": "Gaucho chefs serve all-you-can-eat meats at this easygoing Brazilian place with a gourmet salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-d286-7405-a623-a1b7c110d6f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-d286-7405-a623-a1b7c110d6f2",
        "storage_key": "property/6737460151191767/019e1e2b-d286-7405-a623-a1b7c110d6f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://gauchosdosul.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3542294371129877960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gauchos-do-sul",
      "poi_latitude": "29.9953664",
      "poi_longitude": "-95.5715327",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-953-2398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxwq_4fSQIYRyOUPcfbBKDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_ac327df6-cc6a-4b65-9162-f5d6c757ca5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "The Chefs Table Houston",
      "poi_type": "Restaurants",
      "poi_address": "110 Vintage Park Blvd Building J Suite P, Houston, TX 77070, USA",
      "poi_short_description": "Global fare, including Indian, African, and French options, served in an upscale space with live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-d34f-76ef-9222-887c9bba9207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-d34f-76ef-9222-887c9bba9207",
        "storage_key": "property/6737460151191767/019e1e2b-d34f-76ef-9222-887c9bba9207.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.chefstablehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8762323685163463014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-chefs-table-houston",
      "poi_latitude": "29.9943572",
      "poi_longitude": "-95.572017",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-559-7489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnb8KIafTQIYRZvEohfcGmnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_35b26f18-cc93-496d-a815-a1bf86a95a1a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "The Annex Crafthouse",
      "poi_type": "Restaurants",
      "poi_address": "122 A Vintage Park Blvd, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-d3fc-773c-bb87-e98c32bc9546.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-d3fc-773c-bb87-e98c32bc9546",
        "storage_key": "property/6737460151191767/019e1e2b-d3fc-773c-bb87-e98c32bc9546.webp",
        "width": 1280,
        "height": 655
      },
      "poi_business_url": "http://annexcrafthouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2420485140502364067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-annex-crafthouse",
      "poi_latitude": "29.9952178",
      "poi_longitude": "-95.5712817",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTdZezDTQIYRoz_BN2lKlyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e1e1ff57-be88-4175-975a-3e3b3fd86f83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "La Corona",
      "poi_type": "Restaurants",
      "poi_address": "106 Vintage Park Blvd ste a, Houston, TX 77070, USA",
      "poi_short_description": "Cheery, low-key pick dishing out hearty Mexican staples such as burritos plus beer & tequila drinks.",
      "poi_long_description": "Cheery, low-key pick dishing out hearty Mexican staples such as burritos plus beer & tequila drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-d66e-746d-b2f5-dae38e023772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-d66e-746d-b2f5-dae38e023772",
        "storage_key": "property/6737460151191767/019e1e2b-d66e-746d-b2f5-dae38e023772.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lacoronamexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13075736838661951092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-corona",
      "poi_latitude": "29.9944881",
      "poi_longitude": "-95.570868",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-534-1247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA8FTAMfTQIYRdE7vZGBZdrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0e60d12d-1ed8-42ca-99a0-91480dd6f4af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Potbelly",
      "poi_type": "Restaurants",
      "poi_address": "142 Vintage Park Blvd Ste A, Houston, TX 77070, USA",
      "poi_short_description": "Retro-style counter-serve chain known for made-to-order toasted sandwiches, salads & baked goods.",
      "poi_long_description": "Retro-style counter-serve chain known for made-to-order toasted sandwiches, salads & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-db14-7162-b815-9293d5ecab19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-db14-7162-b815-9293d5ecab19",
        "storage_key": "property/6737460151191767/019e1e2b-db14-7162-b815-9293d5ecab19.webp",
        "width": 1280,
        "height": 814
      },
      "poi_business_url": "https://www.potbelly.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=3347156374908837159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "potbelly",
      "poi_latitude": "29.9959421",
      "poi_longitude": "-95.5739734",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-257-0568",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG16IMYjSQIYRJx0gLv18cy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_53973947-6301-45bf-b866-27e00bf12fd5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10133 Louetta Rd, Houston, TX 77070, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-08a1-748a-b36c-41fa87c40342.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-08a1-748a-b36c-41fa87c40342",
        "storage_key": "property/6737460151191767/019e1e2a-08a1-748a-b36c-41fa87c40342.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/champions?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2037393975922010618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "29.9984967",
      "poi_longitude": "-95.561974",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-803-6396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f006b7f14edd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f006b7f14edd",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f006b7f14edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd4ZD04HSQIYR-ilaygZHRhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_40e3c7ab-57c4-4026-bce1-9cc8d02206f9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "9870 Louetta Rd, Houston, TX 77070, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-da4c-72fb-b0a9-ac5a26934646.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-da4c-72fb-b0a9-ac5a26934646",
        "storage_key": "property/6737460151191767/019e1e2b-da4c-72fb-b0a9-ac5a26934646.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/houston/9870-louetta-rd/fb07",
      "poi_directions_map_url": "https://maps.google.com/?cid=4696418189683119623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "30.0012",
      "poi_longitude": "-95.5601",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f006b7f14edd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f006b7f14edd",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f006b7f14edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-ph2X3NQIYRB9a--HUHLUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8d87ad78-1f42-4be6-b723-5d3c256c175c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "12222 Jones Rd, Houston, TX 77070, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-d66d-739f-b58d-7c107288962d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-d66d-739f-b58d-7c107288962d",
        "storage_key": "property/6737460151191767/019e1e2b-d66d-739f-b58d-7c107288962d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/houston/cypress-n-houston/034/00371?cid=loc_03400371_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17444516304466035406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.9517085",
      "poi_longitude": "-95.5824868",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 832-912-7474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f006b7f14edd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f006b7f14edd",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f006b7f14edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAXcZ1CHSQIYRzkI1ZidfF_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e85da829-bfd9-4260-9646-55d9a4470b4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "21515 Tomball Pkwy, Houston, TX 77070, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-dabf-7559-ad37-82c701999ec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-dabf-7559-ad37-82c701999ec6",
        "storage_key": "property/6737460151191767/019e1e2b-dabf-7559-ad37-82c701999ec6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/tomball-parkway/1124",
      "poi_directions_map_url": "https://maps.google.com/?cid=18267370387860995369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.9994478",
      "poi_longitude": "-95.5842107",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-655-1427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f56-75fc-bf7e-f1f38536c8ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f56-75fc-bf7e-f1f38536c8ff",
        "storage_key": "property/6737460151191767/019e1e2a-3f56-75fc-bf7e-f1f38536c8ff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEZhqo_TSQIYRKb3xRJW8gv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0d42ac24-b8d3-47f8-ae79-fedd14a6d3a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "22605 Texas 249 Access Rd, Tomball, TX 77375, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-da4d-7579-9c53-084efe94f004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-da4d-7579-9c53-084efe94f004",
        "storage_key": "property/6737460151191767/019e1e2b-da4d-7579-9c53-084efe94f004.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5045-tomball-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5957955617875905979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.0142993",
      "poi_longitude": "-95.5947799",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-374-9449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f56-75fc-bf7e-f1f38536c8ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f56-75fc-bf7e-f1f38536c8ff",
        "storage_key": "property/6737460151191767/019e1e2a-3f56-75fc-bf7e-f1f38536c8ff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2UIVNebSQIYRu00JXxHprlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_90dd4e6d-fdd3-42ca-ae8d-a33b917ac418",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "15633 Vintage Preserve Pkwy, Houston, TX 77070, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-e1bd-7239-93a5-9e766028a11f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-e1bd-7239-93a5-9e766028a11f",
        "storage_key": "property/6737460151191767/019e1e2b-e1bd-7239-93a5-9e766028a11f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-15633+vintage+preserve+pkwy-houston-tx-77070/id=16465",
      "poi_directions_map_url": "https://maps.google.com/?cid=16346840253404449938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.0003758",
      "poi_longitude": "-95.560293",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-376-9846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxRZx_dPNQIYRkow66Jmk2-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_6bf4b012-12de-4cae-9e39-8ddf7cebd216",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Kelsey Pharmacy | The Vintage",
      "poi_type": "Shopping & Retail",
      "poi_address": "10701 Vintage Preserve Pkwy, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-df11-726c-9560-cd914857c6db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-df11-726c-9560-cd914857c6db",
        "storage_key": "property/6737460151191767/019e1e2b-df11-726c-9560-cd914857c6db.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://www.kelsey-seybold.com/pharmacy?utm_source=googlemybusiness&utm_medium=backlink&utm_campaign=pharmacy&eid=200001221",
      "poi_directions_map_url": "https://maps.google.com/?cid=3403594067991149958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kelsey-pharmacy--the-vintage",
      "poi_latitude": "29.9915011",
      "poi_longitude": "-95.5717205",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-442-1579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2923-7426-a0c2-d1b89d0dbbf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2923-7426-a0c2-d1b89d0dbbf1",
        "storage_key": "property/6737460151191767/019e1e2c-2923-7426-a0c2-d1b89d0dbbf1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlzPUz3zSQIYRhj09lsX-Oy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_156cc7d5-f571-43ed-a2c9-97a4133fc4b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "21515 Tomball Pkwy, Houston, TX 77070, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-de43-71ed-b884-2a7dee43b238.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-de43-71ed-b884-2a7dee43b238",
        "storage_key": "property/6737460151191767/019e1e2b-de43-71ed-b884-2a7dee43b238.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/21515-tomball-pkwy-houston-tx-77070/storeid=16491?WT.mc_id=LS_GOOGLE_RX_16491",
      "poi_directions_map_url": "https://maps.google.com/?cid=645379359339654275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.9994478",
      "poi_longitude": "-95.5842107",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-379-2861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2923-7426-a0c2-d1b89d0dbbf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2923-7426-a0c2-d1b89d0dbbf1",
        "storage_key": "property/6737460151191767/019e1e2c-2923-7426-a0c2-d1b89d0dbbf1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZhqo_TSQIYRgyzPohvZ9Ag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_eabfeaf9-2ee5-4cbc-9f4b-5c1ac51185b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Stripes",
      "poi_type": "Shopping & Retail",
      "poi_address": "11350 Jones Rd, Houston, TX 77070, USA",
      "poi_short_description": "Convenience store chain with made-to-order & prepared snacks, coffee, cold drinks & sundries.",
      "poi_long_description": "Convenience store chain with made-to-order & prepared snacks, coffee, cold drinks & sundries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-df62-70e1-a3d0-f21db3f3a90c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-df62-70e1-a3d0-f21db3f3a90c",
        "storage_key": "property/6737460151191767/019e1e2b-df62-70e1-a3d0-f21db3f3a90c.webp",
        "width": 1280,
        "height": 794
      },
      "poi_business_url": "http://www.stripesstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9304028230331351011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stripes",
      "poi_latitude": "29.9389522",
      "poi_longitude": "-95.5840737",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-894-0766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-292e-749d-84cb-ebe2342c544e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-292e-749d-84cb-ebe2342c544e",
        "storage_key": "property/6737460151191767/019e1e2c-292e-749d-84cb-ebe2342c544e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9-mF43RQIYR4z8bcWGMHoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_aee56d58-6f17-4a82-bad4-1078c06ab704",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Brill Elementary School",
      "poi_type": "Education",
      "poi_address": "9102 Herts Rd, Klein, TX 77379, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-e40b-7568-a028-03d49479f19f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-e40b-7568-a028-03d49479f19f",
        "storage_key": "property/6737460151191767/019e1e2b-e40b-7568-a028-03d49479f19f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://brill.kleinisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12680224582305641599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brill-elementary-school",
      "poi_latitude": "30.00333809999999",
      "poi_longitude": "-95.5446533",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-484-6150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4bDwvXPNQIYRf_SALBM1-a8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_102dd0de-dbec-4ad1-8d01-5809328899ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Ulrich Intermediate School",
      "poi_type": "Education",
      "poi_address": "10103 Spring Cypress Rd, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-e4cc-742b-b62f-e19b0f377201.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-e4cc-742b-b62f-e19b0f377201",
        "storage_key": "property/6737460151191767/019e1e2b-e4cc-742b-b62f-e19b0f377201.webp",
        "width": 1280,
        "height": 786
      },
      "poi_business_url": "http://ulrich.kleinisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6556365029639774236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ulrich-intermediate-school",
      "poi_latitude": "30.019174",
      "poi_longitude": "-95.5719139",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-375-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH-gv2JTSQIYRHOB44UHj_Fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5df17f4d-a471-41f0-b352-fddb1d3e8e30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Klein Cain High School",
      "poi_type": "Education",
      "poi_address": "10201 Spring Cypress Rd, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-e4ed-7218-9f8d-3cd16b52e214.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-e4ed-7218-9f8d-3cd16b52e214",
        "storage_key": "property/6737460151191767/019e1e2b-e4ed-7218-9f8d-3cd16b52e214.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kleincain.kleinisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14214236698128524494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "klein-cain-high-school",
      "poi_latitude": "30.0161702",
      "poi_longitude": "-95.5747144",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-375-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJywbkY5bSQIYRzqRFefccQ8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7b5fcfda-001a-46f1-8e3a-c72ec19cfa56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "WhiteWater Express Car Wash Corporate Office",
      "poi_type": "Education",
      "poi_address": "106 Vintage Park Blvd #100, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-e54f-745c-96ae-973ab777d0ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-e54f-745c-96ae-973ab777d0ae",
        "storage_key": "property/6737460151191767/019e1e2b-e54f-745c-96ae-973ab777d0ae.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.whitewatercw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10432857450535751973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whitewater-express-car-wash-corporate-office",
      "poi_latitude": "29.9941463",
      "poi_longitude": "-95.5711805",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-367-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw9DaAqzTQIYRJZF4W5P0yJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9372eef8-e1a8-4d40-8ff4-483decdcd80b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Whiz Kids Playhouse",
      "poi_type": "Education",
      "poi_address": "16610 Charterstone Dr, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-edc5-728d-94a2-3517ebab6fd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-edc5-728d-94a2-3517ebab6fd2",
        "storage_key": "property/6737460151191767/019e1e2b-edc5-728d-94a2-3517ebab6fd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4394416531941929333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whiz-kids-playhouse",
      "poi_latitude": "30.0106376",
      "poi_longitude": "-95.5649406",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-376-9955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgSs9tEDTQIYRdbGAnY0a_Dw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_9c81e6fd-b9d1-4223-b374-862b1ce7b9c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Learn&Play Child Care Academy",
      "poi_type": "Education",
      "poi_address": "9803 Spring Cypress Rd, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-e99e-75ff-aa1d-4bde913a48ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-e99e-75ff-aa1d-4bde913a48ab",
        "storage_key": "property/6737460151191767/019e1e2b-e99e-75ff-aa1d-4bde913a48ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11848259449445682718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "learnplay-child-care-academy",
      "poi_latitude": "30.0219453",
      "poi_longitude": "-95.5707547",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-422-3432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYY1FFqPSQIYRHg7gyjF5baQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_60590c8f-a8a3-4bb7-9955-ef6c42a44515",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Not Just Another Daycare",
      "poi_type": "Education",
      "poi_address": "13229 Jones Rd, Houston, TX 77070, USA",
      "poi_short_description": "Family-oriented daycare featuring warm teachers and safe, fun activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-ed68-727b-912c-90798d302f5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-ed68-727b-912c-90798d302f5e",
        "storage_key": "property/6737460151191767/019e1e2b-ed68-727b-912c-90798d302f5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9189705562746991449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "not-just-another-daycare",
      "poi_latitude": "29.9654029",
      "poi_longitude": "-95.5866766",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-807-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhbuUgD7SQIYRWTP3KYVkiH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_1457627c-8208-41a7-af78-aea687f1a68f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "The Honey Tree Preschool & Child Care Center",
      "poi_type": "Education",
      "poi_address": "18629 TX-249, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-ebce-707f-8a4e-439a3174298c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-ebce-707f-8a4e-439a3174298c",
        "storage_key": "property/6737460151191767/019e1e2b-ebce-707f-8a4e-439a3174298c.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.thehoneytreepreschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4407022024553300887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-honey-tree-preschool--child-care-center",
      "poi_latitude": "29.96800459999999",
      "poi_longitude": "-95.5595798",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-955-8033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjTc4oArSQIYRl4PSki7jKD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_78f9056c-de51-44d4-8e27-9381b858c6d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Prairie View A&M University Northwest Houston Center",
      "poi_type": "Education",
      "poi_address": "9449 Grant Rd, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f0df-774a-be4d-bc7ba23143fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f0df-774a-be4d-bc7ba23143fb",
        "storage_key": "property/6737460151191767/019e1e2b-f0df-774a-be4d-bc7ba23143fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pvamu.edu/northwest/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13328076038086030004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-view-am-university-northwest-houston-center",
      "poi_latitude": "29.9659691",
      "poi_longitude": "-95.5587224",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-790-7146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK9Emj_bNQIYRtHKDnYrW9rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_22e98d29-b2ad-4815-92cd-89139578739f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Star Cinema Grill Vintage Park",
      "poi_type": "Entertainment",
      "poi_address": "114 Vintage Park Blvd, Houston, TX 77070, USA",
      "poi_short_description": "Stylish theater chain for new & classic films features cocktails & creative bites served seat-side.",
      "poi_long_description": "Stylish theater chain for new & classic films features cocktails & creative bites served seat-side.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-ef1a-7698-9c6a-7799f9dbd53e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-ef1a-7698-9c6a-7799f9dbd53e",
        "storage_key": "property/6737460151191767/019e1e2b-ef1a-7698-9c6a-7799f9dbd53e.webp",
        "width": 714,
        "height": 533
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/vintagepark",
      "poi_directions_map_url": "https://maps.google.com/?cid=17810722575257162976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill-vintage-park",
      "poi_latitude": "29.9946361",
      "poi_longitude": "-95.5728045",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-715-4707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2924-74a9-b6c0-9b0c471a8576.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2924-74a9-b6c0-9b0c471a8576",
        "storage_key": "property/6737460151191767/019e1e2c-2924-74a9-b6c0-9b0c471a8576.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yskr2LSQIYR4NQ7I9FlLPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_acbb46c8-b1dd-4dc9-880c-fd84792c7e54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "AMC Willowbrook 24",
      "poi_type": "Entertainment",
      "poi_address": "17145 Tomball Pkwy, Houston, TX 77064, USA",
      "poi_short_description": "Movie theater featuring stadium seating and clean facilities, plus a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f085-704c-a567-3c8730b75ec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f085-704c-a567-3c8730b75ec6",
        "storage_key": "property/6737460151191767/019e1e2b-f085-704c-a567-3c8730b75ec6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/houston/amc-willowbrook-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13977105686642768018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-willowbrook-24",
      "poi_latitude": "29.9533684",
      "poi_longitude": "-95.5409804",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-970-9604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2924-74a9-b6c0-9b0c471a8576.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2924-74a9-b6c0-9b0c471a8576",
        "storage_key": "property/6737460151191767/019e1e2c-2924-74a9-b6c0-9b0c471a8576.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJr8uHfeDNQIYRkjhvcJGn-ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f9b6cceb-621d-466e-b7d7-d74e174bb704",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Cinemark Cypress and XD",
      "poi_type": "Entertainment",
      "poi_address": "25720 Northwest Fwy, Cypress, TX 77429, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f593-718e-983e-34e70128ae6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f593-718e-983e-34e70128ae6e",
        "storage_key": "property/6737460151191767/019e1e2b-f593-718e-983e-34e70128ae6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-cypress/cinemark-cypress-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1450943990742131491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-cypress-and-xd",
      "poi_latitude": "29.9700743",
      "poi_longitude": "-95.6885768",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 281-256-7652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2924-74a9-b6c0-9b0c471a8576.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2924-74a9-b6c0-9b0c471a8576",
        "storage_key": "property/6737460151191767/019e1e2c-2924-74a9-b6c0-9b0c471a8576.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJL1syDrjVQIYRIyMsRd_JIhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_120e6b9a-2c98-47cc-b0cc-d42e1a517b0c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Regal Lone Star",
      "poi_type": "Entertainment",
      "poi_address": "24720 Tomball Pkwy, Tomball, TX 77375, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f2f1-76fa-9d69-20974ed35212.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f2f1-76fa-9d69-20974ed35212",
        "storage_key": "property/6737460151191767/019e1e2b-f2f1-76fa-9d69-20974ed35212.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-lone-star-1441?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6328102774990779375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-lone-star",
      "poi_latitude": "30.0416455",
      "poi_longitude": "-95.6054105",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2924-74a9-b6c0-9b0c471a8576.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2924-74a9-b6c0-9b0c471a8576",
        "storage_key": "property/6737460151191767/019e1e2c-2924-74a9-b6c0-9b0c471a8576.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZ19FdUsR4YR7zN9NfLv0Vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_11fb299d-e19c-485a-a31f-dd726142f1c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "iRise Trampoline & Fun Park",
      "poi_type": "Entertainment",
      "poi_address": "7885 Cypress Creek Pkwy STE A, Houston, TX 77070, USA",
      "poi_short_description": "Family entertainment center with trampolines, a soft play area, and video games, plus party rooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f338-7652-866e-c8df04ac76a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f338-7652-866e-c8df04ac76a8",
        "storage_key": "property/6737460151191767/019e1e2b-f338-7652-866e-c8df04ac76a8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://irisepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281424748493793531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "irise-trampoline--fun-park",
      "poi_latitude": "29.96083639999999",
      "poi_longitude": "-95.5427963",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-242-1240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpSuqz-fNQIYR--gZkO6H7XI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_e05b0577-5bea-4919-8d69-a3b99d797e3f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Publik Reserve",
      "poi_type": "Entertainment",
      "poi_address": "12914 FM 1960, Houston, TX 77065, USA",
      "poi_short_description": "Casual bar featuring happy hour, live music, and karaoke, plus a patio and popcorn.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f6cb-779e-b027-3ad32d26cf3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f6cb-779e-b027-3ad32d26cf3c",
        "storage_key": "property/6737460151191767/019e1e2b-f6cb-779e-b027-3ad32d26cf3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publikreserve.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3496869781935255391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publik-reserve",
      "poi_latitude": "29.919722",
      "poi_longitude": "-95.6110221",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-517-0782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-292d-7330-a635-1fa320b06d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-292d-7330-a635-1fa320b06d66",
        "storage_key": "property/6737460151191767/019e1e2c-292d-7330-a635-1fa320b06d66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4Ra4anRQIYRX28MGopghzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_3b337faa-6223-442f-bf5c-690e3d3c9062",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "The Hidden Cellar Wine Bar",
      "poi_type": "Entertainment",
      "poi_address": "16518 House Hahl Rd Suite F, Cypress, TX 77433, USA",
      "poi_short_description": "Casual, easygoing wine bar offering light bites, plus beers & occasional live music.",
      "poi_long_description": "Casual, easygoing wine bar offering light bites, plus beers & occasional live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f6c3-700f-9d9a-176d5999cad0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f6c3-700f-9d9a-176d5999cad0",
        "storage_key": "property/6737460151191767/019e1e2b-f6c3-700f-9d9a-176d5999cad0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hiddencellarcypress.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16933056150307922246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hidden-cellar-wine-bar",
      "poi_latitude": "29.9640388",
      "poi_longitude": "-95.7094071",
      "poi_miles_from_property": "17.9",
      "poi_walking_minutes": "6 hours 34 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 281-304-2940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-292d-7330-a635-1fa320b06d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-292d-7330-a635-1fa320b06d66",
        "storage_key": "property/6737460151191767/019e1e2c-292d-7330-a635-1fa320b06d66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiekL7-rVQIYRRuHYgNpM_uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_e05cd590-18eb-44b4-9f65-c96096f3dc7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "The Frio - Hill Country Grill & The Barn",
      "poi_type": "Entertainment",
      "poi_address": "16410 Mueschke Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Rustic, wood-lined stop for Texas-style comfort fare, wine & brews, with brunch & patio seating.",
      "poi_long_description": "Rustic, wood-lined stop for Texas-style comfort fare, wine & brews, with brunch & patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f6cb-779e-b027-36630bb6b1de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f6cb-779e-b027-36630bb6b1de",
        "storage_key": "property/6737460151191767/019e1e2b-f6cb-779e-b027-36630bb6b1de.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "https://www.friogrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17496030863683505823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-frio---hill-country-grill--the-barn",
      "poi_latitude": "30.0134367",
      "poi_longitude": "-95.7240795",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-256-3746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-292d-7330-a635-1fa320b06d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-292d-7330-a635-1fa320b06d66",
        "storage_key": "property/6737460151191767/019e1e2c-292d-7330-a635-1fa320b06d66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwww213VQIYRn04gYV9jzvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_eaa7da56-320c-42d6-b547-e069969e99dc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Main Street Crossing",
      "poi_type": "Entertainment",
      "poi_address": "111 W Main St, Tomball, TX 77375, USA",
      "poi_short_description": "Local restaurant/bar offering American fare, drinks & weekly live folk & country music.",
      "poi_long_description": "Local restaurant/bar offering American fare, drinks & weekly live folk & country music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-f94b-75c8-bc04-54c9aa31423a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-f94b-75c8-bc04-54c9aa31423a",
        "storage_key": "property/6737460151191767/019e1e2b-f94b-75c8-bc04-54c9aa31423a.webp",
        "width": 1280,
        "height": 836
      },
      "poi_business_url": "http://www.mainstreetcrossing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8483444183328655206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-crossing",
      "poi_latitude": "30.09765609999999",
      "poi_longitude": "-95.6143771",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-290-0431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRSVV0UsR4YRZocom4k_u3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_84c96a4f-f1ee-4a44-9a85-3bf824762280",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Houston Methodist Willowbrook Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "18220 TX-249, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-26c4-762b-bcd7-9a54a15c1e01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-26c4-762b-bcd7-9a54a15c1e01",
        "storage_key": "property/6737460151191767/019e1e2a-26c4-762b-bcd7-9a54a15c1e01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/willowbrook/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=10196221651682341886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-willowbrook-hospital",
      "poi_latitude": "29.967329",
      "poi_longitude": "-95.5504867",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-737-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f5e-7318-bb7b-cf6431221548",
        "storage_key": "property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49I-IO7NQIYR_jOs_5FBgI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_276bf177-2f0c-498c-afdf-34e456fd0c51",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Kelsey-Seybold Clinic | The Vintage",
      "poi_type": "Health and Wellness",
      "poi_address": "10701 Vintage Preserve Pkwy, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-fb3d-757b-988e-592eb78c989f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-fb3d-757b-988e-592eb78c989f",
        "storage_key": "property/6737460151191767/019e1e2b-fb3d-757b-988e-592eb78c989f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kelsey-seybold.com/find-a-location/the-vintage-clinic?utm_source=googlemybusiness&utm_medium=backlink&utm_campaign=location&eid=200000410&cid=googlemybusiness_backlink_location_200000410",
      "poi_directions_map_url": "https://maps.google.com/?cid=3570454738710401384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kelsey-seybold-clinic--the-vintage",
      "poi_latitude": "29.9912333",
      "poi_longitude": "-95.5718088",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-442-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTH0AIjSQIYRaJFx86rNjDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_0e118e61-5789-4625-9b01-116aa9b5f4d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "AFC Urgent Care Vintage",
      "poi_type": "Health and Wellness",
      "poi_address": "10850 Louetta Rd Ste 1500, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-fedd-7340-afca-9fad65622419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-fedd-7340-afca-9fad65622419",
        "storage_key": "property/6737460151191767/019e1e2b-fedd-7340-afca-9fad65622419.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.afcurgentcare.com/vintage/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14910145133961644296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-vintage",
      "poi_latitude": "29.9976313",
      "poi_longitude": "-95.5761324",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-320-2338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKS_1o4nSQIYRCIlNgwB6684",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_cb150fbd-7063-4457-a147-8497511c6e0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Texas Children's Urgent Care The Vintage",
      "poi_type": "Health and Wellness",
      "poi_address": "10420 Louetta Rd Suite 104 Suite 104, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-fc9b-77de-8786-c7e88515ab8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-fc9b-77de-8786-c7e88515ab8d",
        "storage_key": "property/6737460151191767/019e1e2b-fc9b-77de-8786-c7e88515ab8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-urgent-care/vintage",
      "poi_directions_map_url": "https://maps.google.com/?cid=579416405947880747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-urgent-care-the-vintage",
      "poi_latitude": "29.9983625",
      "poi_longitude": "-95.5668806",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-251-0269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYSQ04DSQIYRK5WOvSaACgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_9f2d37a5-eced-4c9e-8119-a366257532ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "15633 Vintage Preserve Pkwy, Houston, TX 77070, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-fc0c-7619-a88d-0e0b5f17ddfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-fc0c-7619-a88d-0e0b5f17ddfc",
        "storage_key": "property/6737460151191767/019e1e2b-fc0c-7619-a88d-0e0b5f17ddfc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-15633+vintage+preserve+pkwy-houston-tx-77070/id=16465",
      "poi_directions_map_url": "https://maps.google.com/?cid=1679781965311500778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "30.0008836",
      "poi_longitude": "-95.5599348",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-376-9846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2923-7426-a0c2-d1b89d0dbbf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2923-7426-a0c2-d1b89d0dbbf1",
        "storage_key": "property/6737460151191767/019e1e2c-2923-7426-a0c2-d1b89d0dbbf1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_rOdn7NQIYR6uF_LszITxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1db44936-e35f-459f-a9a0-2d8e0157606f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Health and Wellness",
      "poi_address": "10919 Louetta Rd, Houston, TX 77070, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-0bf9-748e-9852-85d84fad9bd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-0bf9-748e-9852-85d84fad9bd1",
        "storage_key": "property/6737460151191767/019e1e2a-0bf9-748e-9852-85d84fad9bd1.webp",
        "width": 991,
        "height": 557
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/houston/vintage-park-market-h-e-b-99?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=18423700428466661273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.995375",
      "poi_longitude": "-95.576204",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-257-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f006b7f14edd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f006b7f14edd",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f006b7f14edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ZNvIYrSQIYRmaf3Pu0hrv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b2e3d5fd-7a19-42c7-97bf-20259e9ae87d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "21155 TX-249, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-2131-72be-9db3-28070f1d6f0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-2131-72be-9db3-28070f1d6f0f",
        "storage_key": "property/6737460151191767/019e1e2a-2131-72be-9db3-28070f1d6f0f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/houston-lakewood-forest-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12935170548732691618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.99798",
      "poi_longitude": "-95.58254",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-487-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq35Sx5TTQIYRooROohT1grM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_7772ee45-017b-4bdf-9bab-71499d5ce6ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "7717 Willow Chase Blvd, Houston, TX 77070, USA",
      "poi_short_description": "Chain fitness center offering an expansive gym floor, plus indoor and outdoor pools, and a spa.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-1838-74f8-b798-3e9a4bda17cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-1838-74f8-b798-3e9a4bda17cd",
        "storage_key": "property/6737460151191767/019e1e2a-1838-74f8-b798-3e9a4bda17cd.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/champions.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=445919389281731667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "29.9658808",
      "poi_longitude": "-95.5455862",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-469-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrUeISenNQIYRU8SYbFI5MAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a3c35b67-1c1f-4a18-9750-d45eade764f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "15556 Cutten Rd #100, Houston, TX 77070, USA",
      "poi_short_description": "Chain fitness center offering group workouts combining cardio and strength training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-0471-7271-bdde-c384aceca654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-0471-7271-bdde-c384aceca654",
        "storage_key": "property/6737460151191767/019e1e2c-0471-7271-bdde-c384aceca654.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/houston-texas-0350?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9186920469894617493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "29.9982527",
      "poi_longitude": "-95.5624252",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-656-6645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T3XzIHSQIYRlVnVM35_fn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_089ba4cb-a2ea-433c-859e-475538f5c648",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "10300 Louetta Rd Unit 124, Houston, TX 77070, USA",
      "poi_short_description": "Friendly, low-impact workout classes offered at this studio inspired by yoga, Pilates and ballet.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2b-fe77-7474-a28d-c7d88c06d1da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2b-fe77-7474-a28d-c7d88c06d1da",
        "storage_key": "property/6737460151191767/019e1e2b-fe77-7474-a28d-c7d88c06d1da.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/spring-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12115614432382127531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "29.998774",
      "poi_longitude": "-95.565958",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-761-7910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPXN3JIHSQIYRq427jSJPI6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_9520da89-db93-4a66-93cb-733d0b1099e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Kickerillo-Mischer Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20215 Chasewood Park Dr, Houston, TX 77070, USA",
      "poi_short_description": "This 80-acre preserve features Marshall Lake, fishing piers, a canoe launch, paved trails & more.",
      "poi_long_description": "This 80-acre preserve features Marshall Lake, fishing piers, a canoe launch, paved trails & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-2af6-72a3-a13f-4ff7c51dcaa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-2af6-72a3-a13f-4ff7c51dcaa5",
        "storage_key": "property/6737460151191767/019e1e2a-2af6-72a3-a13f-4ff7c51dcaa5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6601753626346515604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kickerillo-mischer-preserve",
      "poi_latitude": "29.9880604",
      "poi_longitude": "-95.5707369",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-274-4299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgeqkZHvSQIYRlOwHEfIjnls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_43deb546-5a1c-4ad2-b038-a53a53b01777",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "100 Acre Wood Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14236 W Cypress Forest Dr, Houston, TX 77070, USA",
      "poi_short_description": "Nature preserve featuring both paved and mountain bike trails, as well as a skate park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-0243-70c2-a94f-6910d3d798b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-0243-70c2-a94f-6910d3d798b1",
        "storage_key": "property/6737460151191767/019e1e2c-0243-70c2-a94f-6910d3d798b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pct3.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15807606589620152195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "100-acre-wood-preserve",
      "poi_latitude": "29.9834153",
      "poi_longitude": "-95.5772949",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-274-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UAX6GfSQIYRg-du43DmX9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_4861d7df-0fa8-453d-8901-6fbb66472297",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Cy-Champ Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14619 Cutten Rd, Houston, TX 77070, USA",
      "poi_short_description": "Large park with tree-shaded picnic & play areas, a fitness trail & a terrorism-fighters memorial.",
      "poi_long_description": "Large park with tree-shaded picnic & play areas, a fitness trail & a terrorism-fighters memorial.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-03c0-7438-9707-ef2cc49f4686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-03c0-7438-9707-ef2cc49f4686",
        "storage_key": "property/6737460151191767/019e1e2c-03c0-7438-9707-ef2cc49f4686.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.houstontx.gov/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17679072286168930807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cy-champ-park",
      "poi_latitude": "29.9796597",
      "poi_longitude": "-95.5453205",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-395-7061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlW9Pu5bNQIYR91mNl5OuWPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d99cc501-5b9e-4dc8-918c-0d9ddc159645",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Matzke Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13110 Jones Rd, Houston, TX 77070, USA",
      "poi_short_description": "19-acre park boasting a butterfly garden, cricket & soccer fields, playground & walking trails.",
      "poi_long_description": "19-acre park boasting a butterfly garden, cricket & soccer fields, playground & walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-047d-7248-aec2-514f39f7aa5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-047d-7248-aec2-514f39f7aa5c",
        "storage_key": "property/6737460151191767/019e1e2c-047d-7248-aec2-514f39f7aa5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12604258217817641460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matzke-park",
      "poi_latitude": "29.9660896",
      "poi_longitude": "-95.5825871",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-274-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UMe_xXSQIYR9JFRohFS664",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ecc72c1d-dc10-4095-9ec8-f9785964050c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Mandolin Gardens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10315 Summit Bridge Ln, Houston, TX 77070, USA",
      "poi_short_description": "Peaceful park featuring playgrounds and walking trails dotted with flowers and message plaques.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-08b3-712f-8ba9-bc8c1ba32e2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-08b3-712f-8ba9-bc8c1ba32e2e",
        "storage_key": "property/6737460151191767/019e1e2c-08b3-712f-8ba9-bc8c1ba32e2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hcmud230.org/category/general/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17197933359836919438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mandolin-gardens-park",
      "poi_latitude": "29.9700044",
      "poi_longitude": "-95.5728623",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9SSmRLSQIYRjnbrr0VVq-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3aab34ad-0cc1-48c7-8c4e-279f5c167b91",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Champion Forest Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9650 Cypresswood Dr, Houston, TX 77070, USA",
      "poi_short_description": "Clean, grassy park featuring a playground and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-08c1-70c5-abdc-74b4f0b81460.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-08c1-70c5-abdc-74b4f0b81460",
        "storage_key": "property/6737460151191767/019e1e2c-08c1-70c5-abdc-74b4f0b81460.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pct3.com/Explore/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11001961575815935322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "champion-forest-park",
      "poi_latitude": "29.991248",
      "poi_longitude": "-95.5518519",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2tRT4PNQIYRWnUBJ8PRrpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d1be223d-97fe-4097-ab1e-aa795a5ad77f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Little Cypress Creek Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Telge Rd & Spring Cypress Rd, Cypress, TX 77429, USA",
      "poi_short_description": "This 58-acre preserve features 10 artificial ponds, plus hiking, jogging, biking & horseback riding.",
      "poi_long_description": "This 58-acre preserve features 10 artificial ponds, plus hiking, jogging, biking & horseback riding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-0bd4-729d-b0cd-292571813e2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-0bd4-729d-b0cd-292571813e2d",
        "storage_key": "property/6737460151191767/019e1e2c-0bd4-729d-b0cd-292571813e2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pct3.com/Explore/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=17857939697901718803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-cypress-creek-preserve",
      "poi_latitude": "29.9906563",
      "poi_longitude": "-95.6536738",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-274-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVQh9b4jUQIYRE03HMYol1Pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_b74c08ab-09ee-4cf7-b05c-5785dcb58e87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Bud Hadfield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12405 Telge Rd, Cypress, TX 77429, USA",
      "poi_short_description": "Woodland park along Cypress Creek featuring trails, picnic facilities & a disc-golf course.",
      "poi_long_description": "Woodland park along Cypress Creek featuring trails, picnic facilities & a disc-golf course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-09ea-726c-b176-2287299e1f36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-09ea-726c-b176-2287299e1f36",
        "storage_key": "property/6737460151191767/019e1e2c-09ea-726c-b176-2287299e1f36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pct3.com/parks/#bud-hadfield-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13893248628005508644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bud-hadfield-park",
      "poi_latitude": "29.9521101",
      "poi_longitude": "-95.6501665",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUVWQ_7LWQIYRJJZzgAS8zsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_351d59fe-66fc-4339-90b9-f64091fc4b08",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Meyer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7700 Cypresswood Dr, Spring, TX 77379, USA",
      "poi_short_description": "Park with numerous sports fields, exercise stations, trails, a fishing lake, playgrounds & more.",
      "poi_long_description": "Park with numerous sports fields, exercise stations, trails, a fishing lake, playgrounds & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-2c90-76e8-8891-4c93b3ee57aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-2c90-76e8-8891-4c93b3ee57aa",
        "storage_key": "property/6737460151191767/019e1e2a-2c90-76e8-8891-4c93b3ee57aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pct3.com/explore/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3476603191220512341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meyer-park",
      "poi_latitude": "30.0083125",
      "poi_longitude": "-95.5212579",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-274-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2bPpQLNQIYRVSawvS5gPzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ed8e0963-66f4-4b6d-ba73-beca97f1706f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Telge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12400 Pleasant Grove Rd, Cypress, TX 77429, USA",
      "poi_short_description": "Tranquil park with a wetland habitat & a creek, offering nature trails, fishing & a picnic area.",
      "poi_long_description": "Tranquil park with a wetland habitat & a creek, offering nature trails, fishing & a picnic area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-0d82-716b-8793-e4ac14e9a523.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-0d82-716b-8793-e4ac14e9a523",
        "storage_key": "property/6737460151191767/019e1e2c-0d82-716b-8793-e4ac14e9a523.webp",
        "width": 1280,
        "height": 1003
      },
      "poi_business_url": "http://www.pct3.com/parks/#telge-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11158252969660340290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "telge-park",
      "poi_latitude": "29.9540744",
      "poi_longitude": "-95.6480134",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 713-274-3188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJewZowfUQIYRQliN-vQT2po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_306726e6-6993-42a9-a118-4f2a5fd37d3e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Cypress Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "25210 US-290 Frontage Rd., Cypress, TX 77429, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1596-7085-ad43-a0a8211088a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1596-7085-ad43-a0a8211088a5",
        "storage_key": "property/6737460151191767/019e1e2c-1596-7085-ad43-a0a8211088a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8813123989977222512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-park--ride",
      "poi_latitude": "29.9641577",
      "poi_longitude": "-95.6855147",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2940-72b8-add3-17fffbea1974",
        "storage_key": "property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39ayTa3RQIYRcM0QMJOBTno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_3a39b777-3aa9-4f0f-b8c0-0d38cdc5fb2a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Northwest Station Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "18502 Northwest Fwy, Houston, TX 77065, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-12e5-778e-b84c-011f2cd7b292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-12e5-778e-b84c-011f2cd7b292",
        "storage_key": "property/6737460151191767/019e1e2c-12e5-778e-b84c-011f2cd7b292.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15540130698840525853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-station-park--ride",
      "poi_latitude": "29.90224199999999",
      "poi_longitude": "-95.5940473",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2940-72b8-add3-17fffbea1974",
        "storage_key": "property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yxMh1LQQIYRHUyIE4miqdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_4bbf483c-4251-42be-b8b8-477db7106e35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Seton Lake Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "7555 Seton Lake Dr, Houston, TX 77086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-10e5-70fb-b704-dcc1d95efb88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-10e5-70fb-b704-dcc1d95efb88",
        "storage_key": "property/6737460151191767/019e1e2c-10e5-70fb-b704-dcc1d95efb88.webp",
        "width": 640,
        "height": 1280
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6482456173580619487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seton-lake-park--ride",
      "poi_latitude": "29.927816",
      "poi_longitude": "-95.4992725",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2940-72b8-add3-17fffbea1974",
        "storage_key": "property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJHycTo-rOQIYR345PWotP9lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_da478692-1309-40d7-8166-862aaf390521",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Spring Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "17444 Carlsway Rd, Houston, TX 77073, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-14df-75df-98fa-9c4745bc7418.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-14df-75df-98fa-9c4745bc7418",
        "storage_key": "property/6737460151191767/019e1e2c-14df-75df-98fa-9c4745bc7418.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10901163285805218247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-park-and-ride",
      "poi_latitude": "30.0223929",
      "poi_longitude": "-95.4170473",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2940-72b8-add3-17fffbea1974",
        "storage_key": "property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVAFVurKQIYRxznzaEC2SJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_93128580-cd81-4bfa-8ed7-1a90f3e0ac7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Kuykendahl Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "12920 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-15b4-7309-befd-ae00653051f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-15b4-7309-befd-ae00653051f0",
        "storage_key": "property/6737460151191767/019e1e2c-15b4-7309-befd-ae00653051f0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1748857504062468372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kuykendahl-park--ride",
      "poi_latitude": "29.9732042",
      "poi_longitude": "-95.4253799",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2940-72b8-add3-17fffbea1974",
        "storage_key": "property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeCFozDKQIYRFHFrVKIwRRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_5bd54739-f34f-408f-b65b-9e15aaad6fbe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Greenspoint Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "12450 Greenspoint Dr, Houston, TX 77060, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1796-73af-8476-97d0661dc964.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1796-73af-8476-97d0661dc964",
        "storage_key": "property/6737460151191767/019e1e2c-1796-73af-8476-97d0661dc964.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13885348986134268877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenspoint-transit-center",
      "poi_latitude": "29.9483942",
      "poi_longitude": "-95.4100283",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2940-72b8-add3-17fffbea1974",
        "storage_key": "property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4sB7PPJQIYRzQvdzFWrssA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_81e2cb29-d288-4220-b6cb-b5238399b634",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Northwest Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7373 Old Katy Rd, Houston, TX 77024, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1be4-737d-88ac-0fde11653d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1be4-737d-88ac-0fde11653d7b",
        "storage_key": "property/6737460151191767/019e1e2c-1be4-737d-88ac-0fde11653d7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridemetro.org/pages/TC-Northwest.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887889931563584101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-transit-center",
      "poi_latitude": "29.7833768",
      "poi_longitude": "-95.4545941",
      "poi_miles_from_property": "18.3",
      "poi_walking_minutes": "6 hours 50 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3DSrsfGQIYRZUoO4P5F1UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_9c99d129-bf95-4053-bcf4-bf53e4089f00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Addicks Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "14230 Old Katy Rd, Houston, TX 77079, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-22c6-7725-9d36-54ab7116b041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-22c6-7725-9d36-54ab7116b041",
        "storage_key": "property/6737460151191767/019e1e2c-22c6-7725-9d36-54ab7116b041.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6059542481948761620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "addicks-park--ride",
      "poi_latitude": "29.7872884",
      "poi_longitude": "-95.6383329",
      "poi_miles_from_property": "20.1",
      "poi_walking_minutes": "7 hours 23 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2940-72b8-add3-17fffbea1974",
        "storage_key": "property/6737460151191767/019e1e2c-2940-72b8-add3-17fffbea1974.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xDFp93bQIYRFN7xUcjRF1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_592bc40a-79b5-4d9b-b640-775aca5d21bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Houston Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "902 Washington Ave, Houston, TX 77002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1d74-7789-9883-d2ab0e6e30a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1d74-7789-9883-d2ab0e6e30a6",
        "storage_key": "property/6737460151191767/019e1e2c-1d74-7789-9883-d2ab0e6e30a6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=HOS",
      "poi_directions_map_url": "https://maps.google.com/?cid=11885103972172913154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-station",
      "poi_latitude": "29.7674",
      "poi_longitude": "-95.3675056",
      "poi_miles_from_property": "22.3",
      "poi_walking_minutes": "8 hours 18 mins",
      "poi_biking_minutes": "2 hours 16 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0Zm_jO_QIYRAlrzuxdf8KQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_05b75f0f-dee1-4389-8971-5b300e5635bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1c1f-711a-99c1-c32900c0c784.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1c1f-711a-99c1-c32900c0c784",
        "storage_key": "property/6737460151191767/019e1e2c-1c1f-711a-99c1-c32900c0c784.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "20.1",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-41e4-753d-b195-df83cc7e10f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-41e4-753d-b195-df83cc7e10f1",
        "storage_key": "property/6737460151191767/019e1e2a-41e4-753d-b195-df83cc7e10f1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_7f5d53b0-f074-4453-aa17-1065614a34a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "St. Luke's Health - The Vintage Hospital - Houston, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "20171 Chasewood Park Dr, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-25ae-726b-80e5-c96a1d240cb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-25ae-726b-80e5-c96a1d240cb3",
        "storage_key": "property/6737460151191767/019e1e2a-25ae-726b-80e5-c96a1d240cb3.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.stlukeshealth.org/locations/vintage-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897315993380154292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-health---the-vintage-hospital---houston-tx",
      "poi_latitude": "29.9891215",
      "poi_longitude": "-95.5674988",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-534-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f5e-7318-bb7b-cf6431221548",
        "storage_key": "property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6zlYebNQIYRtGsrdPflvc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2a3f8c9c-6545-4d3d-b277-d0c743ef892c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Encompass Health Rehabilitation Hospital The Vintage",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20180 Chasewood Park Dr, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1c74-77bc-b0d1-d1ad47df393c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1c74-77bc-b0d1-d1ad47df393c",
        "storage_key": "property/6737460151191767/019e1e2c-1c74-77bc-b0d1-d1ad47df393c.webp",
        "width": 749,
        "height": 421
      },
      "poi_business_url": "https://www.encompasshealth.com/locations/the-vintage-rehab?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=2913724323019282085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "encompass-health-rehabilitation-hospital-the-vintage",
      "poi_latitude": "29.9901193",
      "poi_longitude": "-95.5711438",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-205-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85LQgnzSQIYRpdb6jtWgbyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_2b6ca278-c700-43f8-bec3-538908ba8e3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Lone Star College-University Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20515 TX-249 S, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-13fb-70cd-a614-d7c094d9c1ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2a-13fb-70cd-a614-d7c094d9c1ec",
        "storage_key": "property/6737460151191767/019e1e2a-13fb-70cd-a614-d7c094d9c1ec.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lonestar.edu/universitypark",
      "poi_directions_map_url": "https://maps.google.com/?cid=7625617800654292855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-university-park",
      "poi_latitude": "29.99231099999999",
      "poi_longitude": "-95.5811617",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-290-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f6d-7088-9d2a-618330962522",
        "storage_key": "property/6737460151191767/019e1e2a-3f6d-7088-9d2a-618330962522.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrwKUnHDSQIYRdwflyPyi02k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a2b33065-4153-4395-838c-f35e5d33de39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Pin Oak Centre Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21638 Texas 249 Access Rd, Houston, TX 77070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1f74-71bf-9d7f-33f50bc66dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1f74-71bf-9d7f-33f50bc66dd3",
        "storage_key": "property/6737460151191767/019e1e2c-1f74-71bf-9d7f-33f50bc66dd3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1255016807949270936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pin-oak-centre-offices",
      "poi_latitude": "30.0026035",
      "poi_longitude": "-95.5824432",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-454-3090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbRDLfPSQIYRmP_1MCO3ahE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    },
    {
      "id": "custom_1c962f78-edd4-4a77-b335-150c276ffaab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Vintage Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "110 Vintage Park Blvd Suite 270, Houston, TX 77070, USA",
      "poi_short_description": "Contemporary complex featuring high-end shops, a spa, casual & fine dining, plus music & events.",
      "poi_long_description": "Contemporary complex featuring high-end shops, a spa, casual & fine dining, plus music & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1f24-766c-b50c-51f7fb5e6d08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1f24-766c-b50c-51f7fb5e6d08",
        "storage_key": "property/6737460151191767/019e1e2c-1f24-766c-b50c-51f7fb5e6d08.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "http://www.vintageparkhouston.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=1617443837326280765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vintage-park",
      "poi_latitude": "29.9942721",
      "poi_longitude": "-95.5723218",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-655-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f56-75fc-bf7e-f1f38536c8ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f56-75fc-bf7e-f1f38536c8ff",
        "storage_key": "property/6737460151191767/019e1e2a-3f56-75fc-bf7e-f1f38536c8ff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJewJ3kGLSQIYRPUj6t5lQchY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_92b2e401-8eca-4e50-829b-791bbd4f66bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare Northwest",
      "poi_type": "Major Employers & Offices",
      "poi_address": "710 Cypress Creek Pkwy, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1ec8-74a9-8ecf-bd971fb1600d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1ec8-74a9-8ecf-bd971fb1600d",
        "storage_key": "property/6737460151191767/019e1e2c-1ec8-74a9-8ecf-bd971fb1600d.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/northwest?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=206156498389039178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-northwest",
      "poi_latitude": "30.0207296",
      "poi_longitude": "-95.4427166",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 281-440-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f5e-7318-bb7b-cf6431221548",
        "storage_key": "property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ970Z4hjLQIYRSvidNj5q3AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_92b8c72f-3365-4ac8-a41e-71776d32a57e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Kindred Hospital Houston Northwest",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11297 Fallbrook Dr, Houston, TX 77065, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-2038-75ea-ba75-5992ebeafff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-2038-75ea-ba75-5992ebeafff4",
        "storage_key": "property/6737460151191767/019e1e2c-2038-75ea-ba75-5992ebeafff4.webp",
        "width": 948,
        "height": 533
      },
      "poi_business_url": "https://www.kindredhospitals.com/locations/texas/houston-northwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=13501144801802895031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kindred-hospital-houston-northwest",
      "poi_latitude": "29.924521",
      "poi_longitude": "-95.5882472",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-517-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f5e-7318-bb7b-cf6431221548",
        "storage_key": "property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01rE4r3RQIYRt76SRKqzXbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fe835efa-3489-495a-83c8-d0d9ae81ef0e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare North Cypress",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21214 Northwest Fwy, Cypress, TX 77429, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2c-1ff1-75d7-8f88-557dd5e531b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-1ff1-75d7-8f88-557dd5e531b4",
        "storage_key": "property/6737460151191767/019e1e2c-1ff1-75d7-8f88-557dd5e531b4.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/north-cypress?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5610823420399779988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-north-cypress",
      "poi_latitude": "29.9260732",
      "poi_longitude": "-95.6311018",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 832-912-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f5e-7318-bb7b-cf6431221548",
        "storage_key": "property/6737460151191767/019e1e2a-3f5e-7318-bb7b-cf6431221548.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-SuGEfRQIYRlABfZiym3U0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_fbe8fd71-d08b-406b-8b9a-55c18addbac0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Cypress Creek MTB Trail parking OFFICIAL",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14234 W Cypress Forest Dr, Houston, TX 77070, USA",
      "poi_short_description": "Vibrant park featuring 13 trails for cyclists and hikers of all skill levels.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019ea919-714d-771f-90c3-87fbf1b1f531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea919-714d-771f-90c3-87fbf1b1f531",
        "storage_key": "property/6737460151191767/019ea919-714d-771f-90c3-87fbf1b1f531.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9693386883718775969&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cypress-creek-mtb-trail-parking-official",
      "poi_latitude": "29.984199",
      "poi_longitude": "-95.5766594",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc",
        "storage_key": "property/6737460151191767/019e1e2a-3f08-74bf-b7fe-9e8d2ae90dcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk0eb72XSQIYRoQR9UgPUhYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5e399cef-736c-416d-b47f-00b4a0c7a395",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "Perry's Steakhouse & Grille",
      "poi_type": "Restaurants",
      "poi_address": "9730 Cypresswood Dr, Houston, TX 77070, USA",
      "poi_short_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_long_description": "People say this steakhouse serves tender and flavorful pork chops, and delicious lobster bisque. They highlight the generous portions, especially during lunch, and the upbeat and friendly atmosphere. They also like the attentive and polite service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019ea919-72c4-75b9-8d3b-686be5011e39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea919-72c4-75b9-8d3b-686be5011e39",
        "storage_key": "property/6737460151191767/019ea919-72c4-75b9-8d3b-686be5011e39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.perryssteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10790569084608181158&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "perrys-steakhouse--grille",
      "poi_latitude": "29.9888141",
      "poi_longitude": "-95.5559343",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-970-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f52-722d-980c-078a4168d25d",
        "storage_key": "property/6737460151191767/019e1e2a-3f52-722d-980c-078a4168d25d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7qQO4TNQIYRpvNhXGnNv5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_e8b0da04-9e7e-43e0-adc6-bd1e972da7d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "poi_name": "UT MD Anderson Cancer Center Northwest Houston Surgical & Specialty Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9922 Louetta Rd, Houston, TX 77070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019ea919-726d-708a-82b2-f4ccc657c73e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea919-726d-708a-82b2-f4ccc657c73e",
        "storage_key": "property/6737460151191767/019ea919-726d-708a-82b2-f4ccc657c73e.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.mdanderson.org/about-md-anderson/our-locations/md-anderson-northwest-houston-surgical-specialty-care.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15989516485883442120&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ut-md-anderson-cancer-center-northwest-houston-surgical--specialty-care",
      "poi_latitude": "30.0012771",
      "poi_longitude": "-95.5612635",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 713-794-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7",
        "storage_key": "property/6737460151191767/019e1e2a-3f22-725e-8a1f-f4e4e83e7bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZiMnFrNQIYRyLNVH4cs5t0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    }
  ],
  "office_hours": [
    {
      "id": "custom_1a4554c4-04b4-447e-9e1e-19c0374481ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1161ea04-fc9a-42aa-bc98-131e129543ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_358d7860-0433-4a15-a38d-992f21b2202f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fde8486d-1599-4186-8c81-afffb4a8f66d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fc4f76a8-bfe3-435b-b498-1ae36d139a00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b955569b-168d-4f21-97d2-3edf76a9f7bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a3f0f62c-d3a4-4a5d-8a92-54614c99b464",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "rating": "4",
      "name": "D C (Tttt)",
      "text": "Amazing place to live. The place is well kept and the amenities are amazing. The best part of living here is the peace and quiet. The neighbors are not noisy, nor do I see a lot of traffic or people roaming around. This is a paradise for introverts like me. The other added bonus is that the complex is not as big as the neighboring ones, and the entrance of the complex is on a road that has little to no traffic driving through it at all times of the day. I'm glad I spotted this place by accident.",
      "date": "2026-05-25",
      "title": "false"
    },
    {
      "id": "custom_ce6e7e3a-4e56-45f8-b542-bd397cb97d35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "rating": "5",
      "name": "Angelina Rivas",
      "text": "I recently visited the property and i was amazed , not only by the property and its amenities but by the amazing customer service i received from sarah ! she was so helpful from the moment i walked in ,to the second i walked out . sarah also gave me a tour and was happy to answer any questions i had . i highly recommend san marino if you’re looking for an apartment in the area .",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_dbb30bb9-ef9f-4809-8a7c-d67a81dac2c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "rating": "5",
      "name": "Jamal Yusuf",
      "text": "Hands down one of the best apartments in Houston TX! Great amenities, awesome location and very professional staff. 5 stars unquestionably!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_e00fd1fb-8420-444d-a653-3c8a4f21f518",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "rating": "5",
      "name": "Joshua Sam-Dakoroma",
      "text": "Mr. David is a Fantastic maintenance guy...",
      "date": "2026-04-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6d030c6e-8dc8-4fbb-8c7a-a7e6de2afd8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019e1e29-f8e0-77e8-a9f9-3f12ef93af0b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e29-f8e0-77e8-a9f9-3f12ef93af0b",
        "storage_key": "property/6737460151191767/019e1e29-f8e0-77e8-a9f9-3f12ef93af0b.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6678da90a61c246e0b4792a3"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fc8-3343-77a3-a02c-0236511c2239",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-san-marino-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767"
    },
    {
      "lead_collector_id": "019a5027-2870-7717-80ce-b7d3736625de",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-san-marino-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-houston-tx",
      "search_query": "pet friendly apartments houston tx",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Houston, TX",
      "h2_subtitle": "Explore our pet friendly apartments in Houston, TX, located in the inviting Cypresswood neighborhood. Discover a welcoming community for you and your furry friends.",
      "page_copy": "San Marino Apartments in Houston, TX, invites you and your furry companions to discover our pet-friendly community. Nestled in the vibrant Cypresswood neighborhood, we offer the ideal setting for every pet lover. With spacious one and two-bedroom floor plans, both you and your pets will have plenty of room to roam. Our community provides exceptional amenities, including a serene patio and convenient recycling options, enhancing the living experience for all our residents.\n\nLocated in the heart of Houston, San Marino Apartments ensures a comfortable and convenient lifestyle for you and your pets. Our commitment to providing a pet-friendly environment makes us a standout choice for those searching for the perfect home. Visit us today to see why San Marino Apartments is a preferred destination for pet lovers seeking quality and affordability in the Houston area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment community pool and hot tub at sunset.",
        "public_id": "019d076f-418f-7469-a820-77e87e1ebb06",
        "storage_key": "property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Houston, TX",
      "seo_description": "Discover pet friendly apartments at San Marino in Houston. Spacious floor plans and great amenities await you in a convenient Cypresswood location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "page_item_url": "gated-community-apartments-cypresswood",
      "search_query": "gated community apartments cypresswood",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Cypresswood",
      "h2_subtitle": "Discover the security of gated community apartments in Cypresswood. Experience peaceful living with exclusive amenities in a welcoming environment.",
      "page_copy": "Welcome to San Marino Apartments, a premier destination offering gated community apartments in the heart of Cypresswood, Houston, TX. Our secure environment provides peace of mind, and our selection of spacious one and two-bedroom floor plans ensures a welcoming abode for you and your loved ones. Enjoy the benefits of a serene, gated setting knowing that comfort and safety are prioritized.\n\nIn addition to our secure surroundings, San Marino Apartments boasts a range of amenities, including a rejuvenating spa, convenient gas range cooking, and a patio perfect for relaxation. Our community is also committed to sustainability with convenient recycling options. Discover a balance of safety, comfort, and modern living by joining our vibrant community at San Marino Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment community pool and hot tub at sunset.",
        "public_id": "019d076f-418f-7469-a820-77e87e1ebb06",
        "storage_key": "property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in Cypresswood",
      "seo_description": "Explore gated community living at San Marino Apartments in Cypresswood, Houston. Discover secure and comfortable apartment life with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-harris-county",
      "search_query": "luxury apartments with fitness center harris county",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Explore luxury apartments with a fitness center in Harris County. Discover upscale living with top-notch amenities and spacious floor plans.",
      "page_copy": "Experience the epitome of luxury living at San Marino Apartments in Harris County, Houston, TX. While our offerings span several upscale amenities, our community is perfect for anyone looking for a luxurious environment with an invigorating fitness lifestyle. Although our beautiful community does not have a dedicated fitness center, our serene patios and convenient access to local amenities provide an active urban environment.\n\nSan Marino Apartments features a variety of luxurious one and two-bedroom floor plans, each designed with your comfort in mind. The modern appeal of our amenities, including a cozy spa and efficient gas range, adds to the deluxe living experience. Choose San Marino Apartments to enjoy the balance of style and convenience in Harris County’s most sought-after neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment community pool and hot tub at sunset.",
        "public_id": "019d076f-418f-7469-a820-77e87e1ebb06",
        "storage_key": "property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments & Amenities in Harris County",
      "seo_description": "Find luxury apartments at San Marino in Harris County. Enjoy spacious living with top-tier amenities in a vibrant Houston neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-77070",
      "search_query": "apartments with air conditioning 77070",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in 77070",
      "h2_subtitle": "Find comfortable apartments with air conditioning in the 77070 area. Stay cool and relaxed in a vibrant community.",
      "page_copy": "San Marino Apartments in Houston, TX, offers comfortable living with air-conditioned accommodations in the heart of the 77070 area. Our spacious one and two-bedroom floor plans are designed to provide a cool and relaxing environment year-round, ensuring you stay comfortable even during the hottest Texas days. Enjoy the added convenience of a well-equipped kitchen with a gas range, a tranquil patio, and efficient heating when needed.\n\nLocated in the dynamic Cypresswood neighborhood, San Marino Apartments combines essential comforts with desirable amenities to create a welcoming community. Experience the balance of comfort and convenience that makes San Marino Apartments a standout choice for those seeking the ideal home in the 77070 area. Schedule a tour today and feel the difference in our air-conditioned spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment community pool and hot tub at sunset.",
        "public_id": "019d076f-418f-7469-a820-77e87e1ebb06",
        "storage_key": "property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in 77070",
      "seo_description": "Discover air-conditioned living at San Marino Apartments in the 77070 area. Enjoy comfort and convenience in spacious one and two-bedroom homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "page_item_url": "dog-park-pet-washing-station-houston",
      "search_query": "dog park and pet washing station in houston",
      "category": "Amenity",
      "h1_title": "Dog Park & Pet Washing Station in Houston",
      "h2_subtitle": "Discover apartments near a dog park and pet washing station in Houston. Ideal pet-friendly living solutions for you and your furry friend.",
      "page_copy": "While San Marino Apartments in Houston, TX, provides a welcoming environment for you and your furry companions, our community is ideally located near local dog parks and pet washing stations, providing all the amenities you need for convenient pet care. Set in the vibrant Cypresswood area, residents can explore nearby pet-friendly facilities, ensuring both you and your pet enjoy a comfortable and engaging lifestyle together.\n\nAt San Marino Apartments, our selection of one and two-bedroom floor plans are spacious enough to accommodate you and your pets comfortably. Enjoy modern amenities such as a cozy patio perfect for outdoor relaxation. Although we do not have an on-site pet washing station just yet, our community's proximity to such pet-friendly resources in Houston makes us the ideal choice for pet lovers. Embrace a lifestyle that caters to both you and your pet in our vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment community pool and hot tub at sunset.",
        "public_id": "019d076f-418f-7469-a820-77e87e1ebb06",
        "storage_key": "property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park & Pet Facilities in Houston",
      "seo_description": "Live near pet facilities at San Marino Apartments in Houston. Ideal location for pet owners looking for homes near dog parks and pet washing stations.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-houston-tx",
      "search_query": "one bedroom apartments houston tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Houston, TX",
      "h2_subtitle": "Explore one bedroom apartments in Houston, TX. Discover spacious living at San Marino Apartments with modern amenities.",
      "page_copy": "San Marino Apartments offers inviting one bedroom apartments in Houston, TX, designed to meet your need for both comfort and style. Located in the charming Cypresswood neighborhood, our community combines convenience and tranquility, making it perfect for singles and couples seeking their ideal home. Each of our one-bedroom units features contemporary amenities and a thoughtful layout that maximizes space and functionality.\n\nBeyond the allure of our interiors, residents can enjoy a variety of community features including a peaceful spa and private patio spaces. Our strategic location allows easy access to local dining and entertainment, making life at San Marino Apartments as vibrant as it is comfortable. Schedule a visit today to see why our one-bedroom apartments are a top choice in the Houston area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment community pool and hot tub at sunset.",
        "public_id": "019d076f-418f-7469-a820-77e87e1ebb06",
        "storage_key": "property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Houston, TX",
      "seo_description": "Find spacious one bedroom apartments at San Marino in Houston, TX. Enjoy modern living with convenient amenities in the vibrant Cypresswood area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191767",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-cypresswood-houston",
      "search_query": "two bedroom apartments in cypresswood houston",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Cypresswood",
      "h2_subtitle": "Discover the ideal two bedroom apartments in Cypresswood, Houston. Experience spacious living with modern amenities at San Marino Apartments.",
      "page_copy": "Experience elevated living at San Marino Apartments with our two bedroom options in the sought-after Cypresswood neighborhood of Houston. Our well-designed two bedroom apartments offer ample space, making them perfect for families or roommates looking for a balanced blend of comfort and convenience. Each unit features key amenities such as a modern gas range kitchen, private patio, and efficient heating to enhance your everyday life.\n\nNestled in a lively community, San Marino Apartments provide more than just a home. Residents can unwind in our onsite spa or engage in recycling initiatives, all within a stone's throw from local shops and dining venues. Our two bedroom apartments are competitively priced to ensure you enjoy the best value without compromising on quality. Discover the perfect blend of location, design, and community at San Marino Apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment community pool and hot tub at sunset.",
        "public_id": "019d076f-418f-7469-a820-77e87e1ebb06",
        "storage_key": "property/6737460151191767/019d076f-418f-7469-a820-77e87e1ebb06.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Cypresswood",
      "seo_description": "Explore spacious two bedroom apartments at San Marino in Cypresswood, Houston. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3403"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483396"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4871557"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M7DBWBG5"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "713-804-6943"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "713-843-7792"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "713-597-6646"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "713-597-6725"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "713-581-3518"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "713-673-8826"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "713-804-8579"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "713-497-1862"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "713-766-5682"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "281-984-6532"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "575-448-8708"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "713-999-2151"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "575-210-5585"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "575-579-6986"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "281-532-8829"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "281-397-3046"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "713-999-9565"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "832-979-9613"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321132574"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "713-581-6152"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "714-582-5987"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "0dea160011ee8531"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "575-500-5299"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "713-497-1844"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "713-903-2514"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "575-517-3806"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "713-543-8767"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "713-575-2765"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "713-673-8708"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.sanmarino-houston.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191767/019e84a0-943f-7779-b6c4-c5021a6b1cd3.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "713-360-2051"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "281-984-6532"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3403",
  "custom_repli_id": "5028483396",
  "custom_realpage_id": "4871557",
  "custom_knock_a_link": "https://www.sanmarino-houston.com?utm_knock=a",
  "custom_knock_g_link": "https://www.sanmarino-houston.com?utm_knock=g",
  "custom_knock_r_link": "https://www.sanmarino-houston.com?utm_knock=r",
  "custom_knock_w_link": "https://www.sanmarino-houston.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-M7DBWBG5",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.sanmarino-houston.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.sanmarino-houston.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.sanmarino-houston.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.sanmarino-houston.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.sanmarino-houston.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.sanmarino-houston.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "713-804-6943",
  "custom_knock_ads_link": "https://www.sanmarino-houston.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.sanmarino-houston.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "713-843-7792",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.sanmarino-houston.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.sanmarino-houston.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.sanmarino-houston.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.sanmarino-houston.com?utm_knock=psa",
  "custom_knock_r_number": "713-597-6646",
  "custom_knock_w_number": "713-597-6725",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "713-581-3518",
  "custom_knock_amap_link": "https://www.sanmarino-houston.com?utm_knock=amap",
  "custom_knock_ar_number": "713-673-8826",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "713-804-8579",
  "custom_knock_fb_number": "713-497-1862",
  "custom_knock_fl_number": "713-766-5682",
  "custom_knock_gp_number": "281-984-6532",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.sanmarino-houston.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "575-448-8708",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.sanmarino-houston.com?utm_knock=bcard",
  "custom_knock_bnr_number": "713-999-2151",
  "custom_knock_cfres_link": "https://www.sanmarino-houston.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "575-210-5585",
  "custom_knock_lgp_number": "575-579-6986",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.sanmarino-houston.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "281-532-8829",
  "custom_knock_psa_number": "281-397-3046",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "713-999-9565",
  "custom_knock_bandit_link": "https://www.sanmarino-houston.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.sanmarino-houston.com?utm_knock=flyers",
  "custom_knock_osoc_number": "832-979-9613",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321132574",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "713-581-6152",
  "custom_knock_cfres_number": "714-582-5987",
  "custom_knock_chatgpt_link": "https://www.sanmarino-houston.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "0dea160011ee8531",
  "custom_knock_dirmail_link": "https://www.sanmarino-houston.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "575-500-5299",
  "custom_knock_propbro_link": "https://www.sanmarino-houston.com?utm_knock=propbro",
  "custom_knock_bandit_number": "713-497-1844",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "713-903-2514",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.sanmarino-houston.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "575-517-3806",
  "custom_knock_dirmail_number": "713-543-8767",
  "custom_knock_propbro_number": "713-575-2765",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "713-673-8708",
  "custom_knock_maintenance_link": "https://www.sanmarino-houston.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191767/019e84a0-943f-7779-b6c4-c5021a6b1cd3.mp4",
  "custom_knock_maintenance_number": "713-360-2051",
  "custom_ppc_tracking_phone_number": "281-984-6532"
};

export const generatedAt = '2026-10-07T17:15:22.806Z';
